import { Component, OnInit, Input, TemplateRef, OnChanges, SimpleChanges, Output, EventEmitter, ChangeDetectorRef, ViewChild, ViewContainerRef, ViewChildren, ElementRef, QueryList, HostListener } from '@angular/core';
import { ItineraryService } from '../itinerary.service';
import { BsModalService, BsDatepickerConfig, BsModalRef, ModalOptions } from 'ngx-bootstrap';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { flightIn, flightOut } from './flight.modal';
import { Observable } from 'rxjs/Observable';
import { UbicacionesService } from '../../home/search-box/service/ubicaciones.service';
import { MatDialog } from '@angular/material/dialog';
import { MaterialModalConfirmComponent } from '../material-modal-confirm/material-modal-confirm.component';
import { DomSanitizer} from "@angular/platform-browser";
import { UserService } from 'app/pages/com.usblick.common/auth/user.service';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import * as moment from 'moment';
import { DatePipe } from '@angular/common';
import CssFilterConverter from 'css-filter-converter';
import { pipe, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, takeUntil } from 'rxjs/operators';
import { FormFlightInternalComponent } from './form-flight-internal/form-flight-internal.component';
import { ConfirmationModalComponent } from '../modals/confirmation-modal/confirmation-modal.component';
moment.locale('es');
@Component({
  selector: 'usb-flight-modal',
  templateUrl: './flight-modal.component.html',
  styleUrls: ['./flight-modal.component.scss'],
  providers: [UbicacionesService, DatePipe]
})
export class FlightModalComponent implements OnInit, OnChanges {

  @Input() invoke: number; // If its 0, comes from sidebar footer, 1 from head-band
  @Input() _actualItinerary: any;
  @Input() payloadSearch: any
  @Input() modeView: any;
  @Input() getClientsSettingAppBooking: any;
  @Input() openModalFly: boolean = false;
  @Input() formTransports: any;
  @Input() infoFly: any;
  @Input() component: string = '';
  @Input() actionComponent: string = '';
  @Output() updateFly = new EventEmitter<boolean>(false);

  @ViewChild("template") template: any;
  @ViewChild(FormFlightInternalComponent) flightInternalComponent!: FormFlightInternalComponent;
  @ViewChildren('icons', { read: ElementRef }) icons : QueryList<ElementRef>;
  checked: boolean = false;

  flightIn: flightIn;
  flightOut: flightOut;
  dpConfig: Partial<BsDatepickerConfig> = new BsDatepickerConfig();
  modalRef: BsModalRef;
  minDate: Date;
  _formFlights: FormGroup;
  config = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true
  };
  ismeridian = true;
  selectedAirportIn: string = '';
  selectedAirportInId: any;
  selectedAirportInCountryCode: any;
    selectedAirlineIn: string = '';
  selectedAirportOut: string = '';
  selectedAirlineOut: any;
  onlyIn: boolean = false;
  onlyOut: boolean = false;

  flightId: any;

  // Modal ref for removal confirmation
  removeConfirmModalRef: BsModalRef;

  // valueAirlineIn: any;
  valueAirlineCodeIata: any;
  minDateDeparture: Date;
  maxDateArrival: Date;
  minDateDeparturateOut: Date;
  minDateArrivalOut: Date;
  maxDateDepartureDateIn: Date = null;
  bsConfig: object;
  message = [];

  isLoadingResult: boolean;
  errorMsg: string;
  keyword = 'nameAirline';

  _flightNumberIn: any;
  __airlineIn: any;
  minArrivalInHour: string | null = null;
  isHoveredCancelDate: boolean;
  flyShowComponent: any;
  flyArr: any[] = [];
  tooltipFlight: boolean = false;
  colorFlight: string;
  countriesList: any[] = [];

  selectedCityIataIn: any;
  valueCityCodeIataIn: any;
  selectedCityIataInName: any;

  selectedIataCityArrivalOutName: any;
  selectedIataCityArrivalOut: any;
  valueCityCodeIataOut: any;

  isFormValidFlyInternal = true;
  flightsInternal: any[] = [];
  isPatching: boolean = false;
  newFlightsArr: any[] = [];
  isChildAccordionOpen = false;
  selectedAirlineInName: string = '';
  selectedAirlineOutName: string = '';
  private _lastFlights: any[] = [];
  private _cachedResult: any[] = [];

  // Wheel time picker support
  activeTimePicker: 'arrivalHourIn' | 'departureHourOut' | null = null;
  currentTime: string = new Date().toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });

  // Tracks previous valid time values for blur revert
  private _previousTimeValues: Record<'arrivalHourIn' | 'departureHourOut', string | null> = {
    arrivalHourIn: null,
    departureHourOut: null,
  };

    private destroy$ = new Subject<void>();

  constructor(
    private modalService: BsModalService,
    private ubicacionesService: UbicacionesService,
    private _formBuilder: FormBuilder,
    private _itineraryService: ItineraryService,
    public dialog: MatDialog,
    private _sanitizer: DomSanitizer,
     public userService: UserService,
     private toastr: ToastrService,
     private cdr: ChangeDetectorRef
    ) {
        this.minDate = new Date();
        this.minDateDeparturateOut = new Date();
        this.minDateArrivalOut = new Date();
        this.minDate.setDate(this.minDate.getDate());
        this.dpConfig.dateInputFormat = "DD/MM/YYYY";
      }


  ngOnInit(): void
              {
                if(this._actualItinerary) {
                  this._actualItinerary.flights = this._actualItinerary?.flights;
                }
                this.colorFlight = this.getClientsSettingAppBooking?.clients_setting_global?.color_main_1;
                this._initData();
              }

  ngOnChanges(changes: SimpleChanges): void
              {

                if(changes['_actualItinerary']?.['currentValue']) {
                  this._actualItinerary = changes['_actualItinerary']['currentValue'];
                  if(this._actualItinerary && this._actualItinerary.flights) {
                    if(this._actualItinerary.flights.length > 0) {
                        this.invoke = 1;
                    }
                    this.getFlyItineraries();
                    this._initFlightsForm();
                  }
                }
                if(this.openModalFly) {
                  this._initData();
                  setTimeout(() => {
                    this.openModalWithClass(this.template);
                  }, 100);
                }
              }

  _initData() {
    this.getFlyItineraries();
    this._initFlightsForm();
    this.invoke = 0;

    if(this._actualItinerary?.flights && this._actualItinerary?.flights.length > 0) {
      this.invoke = 1;
      // this._actualItinerary.flights.push(this._actualItinerary.flights[0]);

    }
  }

  closeModal(): void {
    this.cleanUnsavedFlights();
    this.resetForm();

     if (this.flightInternalComponent) {
      this.flightInternalComponent.resetForms(); // Asegúrate de implementar este método en el hijo
    }

    this.updateFly.emit(true);
    this.modalRef.hide();

  }

  /**
 * Elimina los vuelos internos que no tienen ID (no guardados en BD)
 */
cleanUnsavedFlights(): void {
  if (this.flightsInternal && this.flightsInternal.length > 0) {
    // Filtrar solo los vuelos que tienen ID (ya guardados)
    this.flightsInternal = this.flightsInternal.filter(flight => flight.id !== null && flight.id !== undefined);
  }
}

  /**
 * Elimina un vuelo del itinerario actual previa confirmación del usuario
 *
 * Este método abre un modal de confirmación y, si el usuario acepta, realiza una petición DELETE
 * al endpoint correspondiente para eliminar el vuelo del itinerario actual.
 *
 * @param {number} [index] - Índice opcional del vuelo a eliminar (no utilizado en la implementación actual)
 *
 * @emits updateFly - Evento emitido cuando la eliminación es exitosa
 *
 * @uses MaterialModalConfirmComponent - Componente modal para confirmación de acciones
 * @uses _itineraryService._restService.doDelete - Servicio para realizar peticiones DELETE
 *
 * @example
 * // Ejemplo de uso:
 * this._removeFlight();
 *
 * @response {any} - Respuesta exitosa del servidor
 * @error {HttpErrorResponse} - Error en la petición HTTP
 * @throws {Error} - Error al procesar la eliminación
 */
  _removeFlight(id?: number, first?: boolean) {


    const initialState: ModalOptions = {
      initialState: {
        title: 'Eliminar',
        message: '¿Estas seguro de eliminar este Vuelo?',
        icon: 'assets/icons/itinerary-detail/04-01.svg'
      }
    }

    const modalOptions = Object.assign({}, initialState, this.config, { class: 'gray custom-container-transport' } );
    this.removeConfirmModalRef = this.modalService.show(ConfirmationModalComponent,  modalOptions);


    this.removeConfirmModalRef.content.confirmResult.subscribe((result: boolean) => {
      if(result){
      // const id = this._actualItinerary['id'];
      this._itineraryService._restService.doDelete("app", "fly_itineraries/" + id).subscribe(
        (response: any) => {
          this.toastr.success(`Vuelo eliminado con exito para el file ${id}`);
          if(first === true) {
            this.closeModal();
            this.resetForm();
            this.flightIn = null;
            this.flightOut = null;
          }
            this.flightsInternal = [];
            this.getFlyItineraries();

            this.invoke = 0;
        },
        (error) => {
          this.toastr.error(`Hubo un error al eliminar el vuelo para el file ${id}, ${error.error}`)
          console.log("Delete-Error: ", error);
        }
      );
    } else {
      this.removeConfirmModalRef.hide();
    }
    });
  }

  onFormValidityChange(isValid: boolean): void {
      this.isFormValidFlyInternal = isValid;
  }

  /**
 * Aplica cambios de vuelos al itinerario actual
 *
 * Este método valida el formulario, construye el payload y realiza peticiones POST o PUT
 * según corresponda para crear o actualizar vuelos en el itinerario actual.
 *
 * @returns {void}
 *
 * @emits updateFly - Evento emitido cuando la operación es exitosa
 *
 * @requires _formFlights válido - El formulario debe pasar las validaciones
 * @requires checkFlight() verdadero - Verificación adicional de vuelos
 *
 * @uses payloadMap() - Método para construir el payload de la petición
 * @uses MaterialModalConfirmComponent - Componente modal para confirmación de acciones
 * @uses _itineraryService._restService - Servicio para peticiones HTTP
 *
 * @example
 * // Ejemplo de uso:
 * this._flightsApply();
 *
 * @response {any} - Respuesta exitosa del servidor
 * @error {HttpErrorResponse} - Error en la petición HTTP
 * @throws {Error} - Error al procesar la operación
 */
  _flightsApply() {

    if(this.flightsInternal && this.flightsInternal.length > 0 && !this.isFormValidFlyInternal) {
      this.toastr.info('Tiene formularios de vuelos internos sin completar. Por favor completelos para poder continuar');
      return;
    }

   if (!this._formFlights.valid) {
    this._formFlights.markAllAsTouched();
    return;
    }

      let payloadFly = this.payloadMap();





        if(this._actualItinerary && this._actualItinerary.flights.length > 0) {
          payloadFly['id'] = this._actualItinerary.flights[0].id;
        }

        const initialState: ModalOptions = {
          initialState: {
              title: this._actualItinerary.flights.length === 0 ? 'Crear vuelo' : 'Editar vuelo',
              subtitle: 'para este file',
              message: 'confirme si desea realizar <br /> esta operación',
              icon: '/assets/icons/search-result/airplane_3313713.svg'
            }
          }

        const modalOptions = Object.assign({}, initialState, this.config);
        const modalConfirm = this.modalService.show(ConfirmationModalComponent,  modalOptions);
        const instance = modalConfirm.content as MaterialModalConfirmComponent;

        if (payloadFly['id']) {
          instance.confirmResult.subscribe((result: boolean) =>{
            if(result) {
              this._itineraryService._restService.doPut('app', `fly_itineraries/${payloadFly['id']}`, payloadFly).subscribe({
                next: (res: any) => {
                                      this.toastr.success(`Vuelo actualizado con exito para el file ${this._actualItinerary['id']}`)
                                      this.openModalFly = false;
                                      this.updateFly.emit(true);
                                      this.closeModal();
                                    },
                error: (error: HttpErrorResponse) => {this.toastr.error(`Hubo un error al actualizar el vuelo para el file ${this._actualItinerary['id']}, ${error.error}`)}
              });
            } else {
              return;
            }
          });

        } else {

          instance.confirmResult.subscribe((result: boolean) => {
            if(result) {
              this._itineraryService._restService.doPost('app', 'fly_itineraries', payloadFly).subscribe({
                next: (res: any) => {
                                      this.toastr.success(`Vuelo creado con exito para el file ${this._actualItinerary['id']}`)
                                      this.openModalFly = false;
                                        this.updateFly.emit(true);
                                        this.closeModal();
                                    },
                error: (error: HttpErrorResponse) => {this.toastr.error(`Hubo un error al crear el vuelo para el file ${this._actualItinerary['id']}, ${error.error}`), console.log(error)}
              });
            } else {
              return;
            }
          })
        }




    }

    /**
 * Valida la coherencia temporal entre traslados y vuelos del itinerario
 *
 * Este método realiza validaciones complejas de fechas y horarios para asegurar que:
 * - Los traslados de ida y regreso sean cronológicamente consistentes
 * - Los traslados respeten los tiempos mínimos requeridos respecto a los vuelos
 * - Las fechas de recogida sean anteriores a las de llegada de vuelos
 *
 * @returns {boolean} - `true` si todas las validaciones pasan, `false` si hay inconsistencias
 *
 * @requires formTransports - Formulario de traslados debe estar disponible
 * @requires _actualItinerary.flights - Información de vuelos debe estar cargada
 *
 * @validation
 * - Fecha de recogida ida vs fecha de regreso
 * - Hora de recogida ida vs hora de regreso (mismo día)
 * - Fecha recogida ida vs fecha llegada vuelo
 * - Hora recogida ida vs hora llegada vuelo (+1h15min margen)
 * - Fecha recogida regreso vs fecha salida vuelo
 * - Hora recogida regreso vs hora salida vuelo (+3h30min margen)
 *
 * @uses moment.js - Para formateo y manipulación de fechas
 * @uses toastr - Para mostrar mensajes informativos al usuario
 *
 * @example
 * // Ejemplo de uso:
 * const isValid = this.checkFlight();
 * if (!isValid) {
 *   // Mostrar error al usuario
 * }
 *
 * @message {string} - Mensajes descriptivos de error para cada validación fallida
 */
  checkFlight(): boolean {
      let result = true;
      const a = this.formTransports;

          // Declaración de variables para las fechas y horarios de los traslados
        let firstArrivalDate: string;
        let secondArrivalDate: string | null = null; // Inicializa en `null` si es un viaje de ida
        let firstTime: string;
        let secondTime: string;
        let arrivalHourIn: string;
        let arrivalDateIn: string;
        let departureDateOut: string;
        let departureHourOut: string;
        let st: number = 0; // Inicializa `st` en 0 para evitar errores si no se asigna
        let ft: number;
        let message: string = '';

        if(a) {
          // Obtiene la fecha y hora del primer traslado
          firstArrivalDate = moment(a['firstArrivalDate'].toString().split(',')[0]).format('YYYY-MM-DD');
          firstTime = moment(a['firstTime'].toString().split(',')[0]).format('HH:mm');

          // Convierte la hora a minutos totales en el día (Ej: 14:30 → 870 minutos)
          ft = parseInt(firstTime.split(':')[0], 10) * 60 + parseInt(firstTime.split(':')[1], 10);

          // Si el tipo de viaje no es "oneTrip" (solo ida), obtiene los datos del segundo traslado
          if (a['type'] !== 'oneTrip') {
              secondArrivalDate = moment(a['secondArrivalDate'].toString().split(',')[0]).format('YYYY-MM-DD');
              secondTime = moment(a['secondTime'].toString().split(',')[0]).format('HH:mm');
              st = parseInt(secondTime.split(':')[0], 10) * 60 + parseInt(secondTime.split(':')[1], 10);
          }

          // Validaciones de los traslados
          if (firstArrivalDate > (secondArrivalDate || firstArrivalDate)) {
              result = false;
              message = `Error, ingrese una fecha de recogida de ida anterior a la de regreso: ${firstArrivalDate}`;
          }

          if ((ft > st) && (firstArrivalDate === secondArrivalDate)) {
              result = false;
              message = `Error, ingrese una hora de recogida de ida anterior a la de regreso: ${secondTime}`;
          }
        }

        // Validaciones en relación con los vuelos
        if ((this._actualItinerary.flights && this._actualItinerary.flights.length > 0 && this._actualItinerary.flights[0].id)) {

            const fly =  this._actualItinerary.flights[0];
            // Obtiene los datos del vuelo
            arrivalDateIn = moment(fly.arrivalIn.toString().split(',')[0]).format('YYYY-MM-DD');
            arrivalHourIn = moment(fly.arrivalIn.toString().split(',')[0]).format('HH:mm');
            const at = parseInt(arrivalHourIn.split(':')[0], 10) * 60 + parseInt(arrivalHourIn.split(':')[1], 10);

            departureDateOut = moment(fly.departureOut.toString().split(',')[0]).format('YYYY-MM-DD');
            departureHourOut = moment(fly.departureOut.toString().split(',')[0]).format('HH:mm');
            const _at = parseInt(departureHourOut.split(':')[0], 10) * 60 + parseInt(departureHourOut.split(':')[1], 10);

            // Verifica si el primer traslado es antes de la llegada del vuelo
            if (firstArrivalDate > arrivalDateIn) {
                result = false;
                message = `Error, la fecha de recogida de ida debe ser anterior a la llegada del vuelo: ${arrivalDateIn}`;
            }

            // Ajuste de tiempo mínimo de espera (1 hora y 15 minutos) entre el traslado y el vuelo
            ft = ft + 75;
            if ((ft > at) && (firstArrivalDate === arrivalDateIn)) {
                result = false;
                message = `Error, la hora de recogida de ida debe ser al menos 1h 15min antes de la llegada del vuelo: ${arrivalHourIn}`;
            }

            // Verifica si el segundo traslado es después de la salida del vuelo
            if (secondArrivalDate && secondArrivalDate > departureDateOut) {
                result = false;
                message = `Error, la fecha de recogida de regreso debe ser anterior a la salida del vuelo: ${departureDateOut}`;
            }

            // Ajuste de tiempo mínimo de espera (3 horas y 30 minutos) entre el traslado y la salida del vuelo
            st = st + 210;
            if ((st > _at) && (secondArrivalDate === departureDateOut)) {
                result = false;
                message = `Error, la hora de recogida de regreso debe ser al menos 3h 30min antes de la salida del vuelo: ${departureHourOut}`;
            }
        }

        if(message !== '') {
          this.toastr.info(message);
        }


      return result;
  }

  /**
 * Construye el payload para operaciones CRUD de vuelos
 *
 * Este método mapea los valores del formulario de vuelos a un objeto estructurado
 * apto para ser enviado al backend en operaciones POST/PUT.
 *
 * @returns {any} - Objeto payload estructurado para la API
 *
 * @requires _formFlights - Formulario de vuelos debe estar disponible y con controles definidos
 * @requires userService._agentID - ID del agente debe estar disponible
 * @requires selectedAirportInCountryCode - Código IATA del país del aeropuerto de entrada
 * @requires selectedAirportInId - ID del aeropuerto de entrada
 *
 * @structure
 * - Propiedades base: agent_id, iata_code, id_airport, itinerary
 * - Objeto `in`: Datos del vuelo de entrada (si existe)
 * - Objeto `out`: Datos del vuelo de salida (si existe)
 *
 * @uses formatDateOnly() - Método auxiliar para formatear fechas
 * @uses getVal() - Función helper para obtener valores del formulario
 *
 * @example
 * // Ejemplo de uso:
 * const payload = this.payloadMap();
 * this.service.saveFlight(payload).subscribe(...);
 *
 * @note Los valores nulos se manejan con operador de coalescencia nula (??)
 * @note Las fechas se combinan con sus respectivas horas
 */
   payloadMap(): any {

    const getVal = (control: string) => this._formFlights.get(control)?.value;

    const arrivalDateIn = this.formatDateOnly(getVal('arrivalDateIn'));
    const departureDateOut = this.formatDateOnly(getVal('departureDateOut'));

    let itineraryId: number = -1;

    if(this.flyShowComponent && this.flyShowComponent?.id) {
      itineraryId = this.flyShowComponent.id;
    }

    if(itineraryId === -1) {
       itineraryId = this._actualItinerary['id']
    }


        let payload: any = {
          agent_id: this.userService._agentID,
          iata_code: this.selectedAirportInCountryCode,
          id_airport: this.selectedAirportInId,
          itinerary: itineraryId,

        };

    if(getVal('airlineIn')?.name) {
      payload.in = {
        airline: getVal('airlineIn')?.name ?? null,
        airlineIataCode: getVal('airlineIn')?.iata ?? null,
        airport: getVal('airportIn')?.name ?? null,
        airportIataCode: this.selectedAirportIn,
        // iataCityDeparture: getVal('cityDepartureIn'),
        flyNumber: getVal('flightNumberIn') ?? null,
        arrival: `${arrivalDateIn} ${getVal('arrivalHourIn')}`,
      }
    }

    if(getVal('airlineOut')?.name) {
      payload.out = {
          airline: getVal('airlineOut')?.name ?? null,
          airlineIataCode: getVal('airlineOut')?.iata ?? null,
          // iataCityArrival: getVal('iataCityArrivalOut'),
          airport: getVal('airportOut')?.name ?? null,
          airportIataCode: this.selectedAirportOut,
          flyNumber: getVal('flightNumberOut') ?? null,
          departure: `${departureDateOut} ${getVal('departureHourOut')}`,
          // arrival: `${arrivalDateOut} ${getVal('arrivalHourOut')}`,
      }
    }

    return payload;
  }

/**
 * Formatea un objeto Date a string en formato ISO (YYYY-MM-DD) sin información de tiempo
 *
 * Este método utility toma un objeto Date y extrae solo la parte de la fecha (año, mes, día),
 * ignorando cualquier información de hora, minutos, segundos y zona horaria.
 *
 * @param {Date} date - Objeto Date a formatear
 * @returns {string} - String con la fecha en formato ISO (YYYY-MM-DD) o undefined si la fecha es falsy
 *
 * @example
 * // Ejemplo de uso:
 * const date = new Date('2023-12-25T15:30:00');
 * const formatted = this.formatDateOnly(date); // Retorna "2023-12-25"
 *
 * @note Retorna undefined si el parámetro date es null, undefined o falsy
 * @note Usa el constructor de Date con componentes específicos para evitar problemas de zona horaria
 * @note El método toISOString() siempre retorna la fecha en UTC
 *
 * @implementation
 * 1. Crea un nuevo Date object usando solo año, mes y día
 * 2. Convierte a formato ISO string
 * 3. Extrae los primeros 10 caracteres (YYYY-MM-DD)
 */
  private formatDateOnly(date: Date): string {
    if(!date) {
      return;
    }
  const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  return d.toISOString().slice(0, 10);
}

/**
 * Abre un modal con clase personalizada y configura el estado según la acción
 *
 * Este método abre un modal Bootstrap con clases CSS personalizadas y realiza
 * diferentes inicializaciones basadas en el componente y acción especificados.
 *
 * @param {TemplateRef<any>} template - Template reference del modal a abrir
 * @param {string} [action] - Acción a realizar: 'new' para nuevo vuelo, otros valores para edición
 * @param {any} [infoFly] - Información del vuelo existente para edición (opcional)
 *
 * @uses modalService.show() - Servicio de modales de Bootstrap
 * @uses _initData() - Inicializa datos para nuevo vuelo
 * @uses resetForm() - Reinicia formulario para nuevo vuelo
 * @uses patchForm() - Rellena formulario con datos existentes
 *
 * @example
 * // Abrir modal para nuevo vuelo:
 * this.openModalWithClass(template, 'new');
 *
 * // Abrir modal para editar vuelo existente:
 * this.openModalWithClass(template, 'edit', flightData);
 *
 * @configuration
 * - Clase CSS: 'gray modal-lg custom-container-transport'
 * - Configuración base: this.config
 *
 * @componentBehavior
 * - Si component === 'fly' AND action === 'new': Inicializa datos y resetea formulario
 * - Si component === 'fly' AND action !== 'new': Parchea formulario con infoFly
 * - Si component === 'results': Parchea formulario (sin info específica)
 */
  openModalWithClass(template: TemplateRef<any>, action?: string, infoFly?: any) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, this.config, { class: 'gray modal-lg custom-container-transport' })
    );

    if(this.component === 'fly' && action === 'new') {
      this._initData();
      this.resetForm();
    }

    if(this.component === 'fly' && action !== 'new') {
      this.flyShowComponent = infoFly;
      this._initData();
      setTimeout(() => {
        this.patchForm(infoFly);
      }, 0);
    }
    if(this.component === 'results') {
      setTimeout(() => {
        this.patchForm();
      }, 0);
    }


  }

  /**
 * Inicializa los objetos de vuelo de entrada y salida con valores por defecto
 *
 * Este método prepara las estructuras de datos para almacenar información de vuelos,
 * estableciendo todas las propiedades a null como estado inicial.
 *
 * @returns {void}
 *
 * @structure flightIn - Objeto para vuelo de entrada (llegada)
 * @property {Date|null} arrivalDateIn - Fecha de llegada del vuelo de entrada
 * @property {any|null} airportIn - Información del aeropuerto de entrada
 * @property {string|null} airportIataCodeIn - Código IATA del aeropuerto de entrada
 * @property {any|null} airlineIn - Información de la aerolínea de entrada
 * @property {string|null} _flightNumberIn - Número de vuelo de entrada (interno)
 * @property {string|null} flightNumberIn - Número de vuelo de entrada
 * @property {string|null} airlineIataCodeOut - Código IATA de aerolínea de salida (¿typo?)
 *
 * @structure flightOut - Objeto para vuelo de salida (regreso)
 * @property {Date|null} departureDateOut - Fecha de salida del vuelo de salida
 * @property {string|null} airportIataCodeOut - Código IATA del aeropuerto de salida
 * @property {any|null} airportOut - Información del aeropuerto de salida
 * @property {any|null} airlineOut - Información de la aerolínea de salida
 * @property {string|null} _flightNumberOut - Número de vuelo de salida (interno)
 * @property {string|null} flightNumberOut - Número de vuelo de salida
 * @property {string|null} airlineIataCodeOut - Código IATA de aerolínea de salida
 *
 * @note La propiedad `arrivalDateOut` en flightOut está comentada, posiblemente no utilizada
 * @note airlineIataCodeOut aparece en ambos objetos, posible duplicación en flightIn
 *
 * @example
 * // Ejemplo de uso:
 * this.iniFlightObject();
 * // Ahora flightIn y flightOut están inicializados con null values
 */
  iniFlightObject() {
    this.flightIn = {

      arrivalDateIn: null,
      airportIn: null,
      airportIataCodeIn: null,
      airlineIn: null,
      _flightNumberIn: null,
      flightNumberIn: null,
      airlineIataCodeOut : null,
    };
    this.flightOut = {
      departureDateOut: null,
      // arrivalDateOut: null,
      airportIataCodeOut: null,
      airportOut: null,
      airlineOut: null,
      _flightNumberOut: null,
      flightNumberOut: null,
      airlineIataCodeOut : null
    };

  }

  /***********************************************Auto Complete********************************************/
  /**
 * Formatea la visualización de aeropuertos en listas desplegables
 *
 * Este método genera HTML seguro para mostrar información de aeropuertos en formatos
 * personalizados dentro de componentes de autocompletado o selección.
 *
 * @param {any} data - Objeto con los datos del aeropuerto
 * @param {string} data.name - Nombre del aeropuerto
 * @param {string} data.iata - Código IATA del aeropuerto
 *
 * @returns {SafeHtml} - HTML sanitizado y seguro para renderizar
 *
 * @uses DomSanitizer.bypassSecurityTrustHtml - Para permitir HTML seguro
 * @uses capitalize() - Método para capitalizar el nombre del aeropuerto
 *
 * @format
 * - Ícono de avión (fa-plane)
 * - Nombre del aeropuerto capitalizado
 * - Código IATA entre paréntesis en negrita
 *
 * @example
 * // Retorna: HTML con "José Martí (HAV)"
 * this._myListFormatterAirport({name: 'josé martí', iata: 'HAV'});
 */
  _myListFormatterAirport = (data: any) => {
    // fa fa-building-o
    const html = `<span class='fa fa-plane'style='color:#a9a4a4'>
                      </span>
                      <span style='font-size:15px;cursor:pointer;line-height:2.1;'>
                        ${ this.capitalize(data['name'])}
                      </span>
                      <span style=' font-weight: 500;font-size:14px;color:black'>
                       (${data['iata']})
                      </span>`;
     return this._sanitizer.bypassSecurityTrustHtml(html);
  }

/**
 * Formatea la visualización de aerolíneas en listas desplegables
 *
 * Este método genera HTML seguro para mostrar información de aerolíneas en formatos
 * personalizados dentro de componentes de autocompletado o selección.
 *
 * @param {any} data - Objeto con los datos de la aerolínea
 * @param {string} data.name - Nombre de la aerolínea
 * @param {string} data.iata - Código IATA de la aerolínea
 *
 * @returns {SafeHtml} - HTML sanitizado y seguro para renderizar
 *
 * @uses DomSanitizer.bypassSecurityTrustHtml - Para permitir HTML seguro
 *
 * @format
 * - Ícono de avión (fa-plane)
 * - Nombre de la aerolínea
 * - Código IATA entre paréntesis en negrita
 *
 * @example
 * // Retorna: HTML con "Cubana de Aviación (CU)"
 * this._myListFormatterAirline({name: 'Cubana de Aviación', iata: 'CU'});
 */
  _myListFormatterAirline = (data: any) => {

      const html = `<span class='fa fa-plane'style='color:#a9a4a4'>
      </span>
      <span style='font-size:15px;cursor:pointer;line-height:2.1;'>
        ${ data['name']}
      </span>
      <span style=' font-weight: 500;font-size:14px;color:black'>
       (${data['iata']})
      </span>`;

    return this._sanitizer.bypassSecurityTrustHtml(html);

  }

/**
 * Capitaliza cada palabra de una cadena de texto
 *
 * Este método utility convierte una cadena a formato de título, capitalizando
 * la primera letra de cada palabra y poniendo el resto en minúsculas.
 *
 * @param {any} val - Valor a capitalizar (se convierte a string)
 * @returns {string} - Cadena capitalizada
 *
 * @transformation
 * 1. Convierte a minúsculas
 * 2. Elimina espacios en blanco al inicio y final
 * 3. Divide por espacios
 * 4. Capitaliza cada palabra
 * 5. Une con espacios
 *
 * @example
 * // Retorna: "José Martí International Airport"
 * this.capitalize("josé martí international airport");
 *
 * @example
 * // Retorna: "New York"
 * this.capitalize("NEW YORK");
 */
  capitalize(val: any) {
    return val.toLowerCase()
            .trim()
            .split(' ')
            .map( v => v[0].toUpperCase() + v.substr(1) )
            .join(' ');
  }

  /**
 * Callback para manejar la selección de aeropuerto de entrada
 *
 * Este método se ejecuta cuando se selecciona un aeropuerto en componentes de entrada
 * y actualiza las propiedades relacionadas con el aeropuerto de llegada.
 *
 * @param {any} data - Objeto con datos del aeropuerto seleccionado
 * @param {number} data.id - ID del aeropuerto
 * @param {string} data.country_code - Código de país del aeropuerto
 * @param {string} data.iata - Código IATA del aeropuerto
 * @param {string} data.nameAirport - Nombre del aeropuerto
 * @param {string} data.codeIataAirport - Código IATA del aeropuerto (alternativo)
 *
 * @returns {string} - Cadena formateada para display: "Nombre (IATA) (IATA)"
 *
 * @sideEffects
 * - Actualiza selectedAirportInId con el ID del aeropuerto
 * - Actualiza selectedAirportInCountryCode con el código de país
 * - Actualiza selectedAirportIn con el código IATA
 *
 * @condition
 * - Si hay payloadSearch y es categoría 8 con pickupLocation tipo 'airport',
 *   aplica lógica específica de transfers
 *
 * @example
 * // Retorna: "José Martí (HAV) (HAV)"
 * this._myCallbackAirportIn({
 *   id: 123,
 *   country_code: 'CU',
 *   iata: 'HAV',
 *   nameAirport: 'José Martí',
 *   codeIataAirport: 'HAV'
 * });
 */
  _myCallbackAirportIn(data: any): string {
    if (data) {
      this.selectedAirportInId = data['id'];
      this.selectedAirportInCountryCode = data['country_code'];
      this.selectedAirportIn = data['iata']; // codeIataCity
     return `${data['nameAirport']} (${data['codeIataAirport']}) (${data['codeIataAirport']})`;
    }
  }

  /**
 * Callback para manejar la selección de aeropuerto de salida
 *
 * Este método se ejecuta cuando se selecciona un aeropuerto en componentes de salida
 * y actualiza las propiedades relacionadas con el aeropuerto de partida.
 *
 * @param {any} data - Objeto con datos del aeropuerto seleccionado
 * @param {string} data.name - Nombre del aeropuerto
 * @param {string} data.iata - Código IATA del aeropuerto
 * @param {string} data.country_code - Código de país del aeropuerto
 *
 * @returns {string} - Cadena formateada para display: "Nombre (IATA)"
 *
 * @sideEffects
 * - Actualiza selectedAirportOut con el código IATA
 * - En condiciones específicas de transfers, actualiza propiedades de aeropuerto de entrada
 *
 * @condition
 * - Si hay payloadSearch, es categoría 8, pickupLocation no es 'airport'
 *   y dropoffLocation es 'airport', actualiza propiedades de aeropuerto de entrada
 *
 * @example
 * // Retorna: "Juan Gualberto Gómez (VRA)"
 * this._myCallbackAirportOut({
 *   name: 'Juan Gualberto Gómez',
 *   iata: 'VRA',
 *   country_code: 'CU'
 * });
 */
  _myCallbackAirportOut(data: any): string {
   if (data) {
    this.selectedAirportInCountryCode = data['country_code'];
    // this.selectedAirportIn = data['iata']; // codeIataCity
    this.selectedAirportOut =  data['iata']; //his._airportOut['codeIataAirport'];
    return `${data['name']} (${data['iata']})`;
   }
  }

  /**
 * Callback para manejar la selección de aerolínea de entrada
 *
 * Este método se ejecuta cuando se selecciona una aerolínea en componentes de entrada
 * y actualiza las propiedades relacionadas con la aerolínea de llegada.
 *
 * @param {any} data - Objeto con datos de la aerolínea seleccionada
 * @param {string} data.name - Nombre de la aerolínea
 * @param {string} data.iata - Código IATA de la aerolínea
 *
 * @returns {string} - Cadena formateada para display: "Nombre (IATA)"
 *
 * @sideEffects
 * - Actualiza selectedAirlineIn con el código IATA de la aerolínea
 * - Actualiza valueAirlineCodeIata con el código IATA seleccionado
 * - Parchea el formulario _formFlights con _flightNumberIn
 *
 * @example
 * // Retorna: "Cubana de Aviación (CU)"
 * this._myCallbackAirlineIn({
 *   name: 'Cubana de Aviación',
 *   iata: 'CU'
 * });
 */
  _myCallbackAirlineIn(data: any): string {
    if (data) {
      this.selectedAirlineIn = data['iata'];
      this.selectedAirlineInName = data['name'];
      this.valueAirlineCodeIata = this.selectedAirlineIn;
      this._formFlights.patchValue({
        _flightNumberIn:  this.selectedAirlineIn,
      });
      return `${data['name']} (${data['iata']})`;
    }
  }

  /**
 * Callback para manejar la selección de aerolínea de salida
 *
 * Este método se ejecuta cuando se selecciona una aerolínea en componentes de salida
 * y actualiza las propiedades relacionadas con la aerolínea de partida.
 *
 * @param {any} data - Objeto con datos de la aerolínea seleccionada
 * @param {string} data.name - Nombre de la aerolínea
 * @param {string} data.iata - Código IATA de la aerolínea
 *
 * @returns {string} - Cadena formateada para display: "Nombre (IATA)"
 *
 * @sideEffects
 * - Actualiza selectedAirlineOut con el código IATA de la aerolínea
 * - Parchea el formulario _formFlights con _flightNumberOut
 *
 * @example
 * // Retorna: "American Airlines (AA)"
 * this._myCallbackAirlineOut({
 *   name: 'American Airlines',
 *   iata: 'AA'
 * });
 */
  _myCallbackAirlineOut(data: any): string {
   if (data) {
     this.selectedAirlineOut = data['iata'];
     this.selectedAirlineOutName = data['name'];
     this._formFlights.patchValue({
       _flightNumberOut:  this.selectedAirlineOut,
     });
    return `${data['name']} (${data['iata']})`;
   }
  }

  /**
 * Callback para manejar la selección de ciudad IATA de entrada
 *
 * Este método se ejecuta cuando se selecciona una ciudad en componentes de entrada
 * y actualiza las propiedades relacionadas con la ciudad de origen del vuelo.
 *
 * @param {any} data - Objeto con datos de la ciudad seleccionada
 * @param {string} data.city_name - Nombre de la ciudad
 * @param {string} data.country_name - Nombre del país
 * @param {string} data.city_iata_code - Código IATA de la ciudad
 *
 * @returns {string} - Cadena formateada para display: "Ciudad, País"
 *
 * @sideEffects
 * - Actualiza selectedCityIataInName con "Ciudad, País"
 * - Actualiza selectedCityIataIn con el código IATA de la ciudad
 * - Actualiza valueCityCodeIataIn con el código IATA seleccionado
 * - Parchea el formulario _formFlights con cityDepartureIn
 *
 * @example
 * // Retorna: "La Habana, Cuba"
 * this._myCallbackCityIataIn({
 *   city_name: 'La Habana',
 *   country_name: 'Cuba',
 *   city_iata_code: 'HAV'
 * });
 */
    _myCallbackCityIataIn(data: any): string {

    if (data) {
      this.selectedCityIataInName = `${data['city_name']}, ${data['country_name']}`;
      this.selectedCityIataIn = data['city_iata_code'];
      this.valueCityCodeIataIn = this.selectedCityIataIn;
      this._formFlights.patchValue({
        cityDepartureIn:  this.selectedCityIataIn,
      });
      return `${data['city_name']}, ${data['country_name']}`;
    }
  }

  /**
 * Callback para manejar la selección de ciudad IATA de salida
 *
 * Este método se ejecuta cuando se selecciona una ciudad en componentes de salida
 * y actualiza las propiedades relacionadas con la ciudad de destino del vuelo.
 *
 * @param {any} data - Objeto con datos de la ciudad seleccionada
 * @param {string} data.city_name - Nombre de la ciudad
 * @param {string} data.country_name - Nombre del país
 * @param {string} data.city_iata_code - Código IATA de la ciudad
 *
 * @returns {string} - Cadena formateada para display: "Ciudad, País"
 *
 * @sideEffects
 * - Actualiza selectedIataCityArrivalOutName con "Ciudad, País"
 * - Actualiza selectedIataCityArrivalOut con el código IATA de la ciudad
 * - Actualiza valueCityCodeIataOut con el código IATA seleccionado
 * - Parchea el formulario _formFlights con iataCityArrivalOut
 *
 * @example
 * // Retorna: "Miami, Estados Unidos"
 * this._myCallbackCityIataOut({
 *   city_name: 'Miami',
 *   country_name: 'Estados Unidos',
 *   city_iata_code: 'MIA'
 * });
 */
  _myCallbackCityIataOut(data: any): string {
    if (data) {
      this.selectedIataCityArrivalOutName = `${data['city_name']}, ${data['country_name']}`;
      this.selectedIataCityArrivalOut = data['city_iata_code'];
      this.valueCityCodeIataOut = this.selectedIataCityArrivalOut;
      this._formFlights.patchValue({
        iataCityArrivalOut:  this.selectedIataCityArrivalOut,
      });
      return `${data['city_name']}, ${data['country_name']}`;
    }
  }

  /**
 * Factory function que retorna una función de autocompletado para aeropuertos o aerolíneas
 *
 * Este método genera funciones de búsqueda para componentes de autocompletado que
 * se conectan con el servicio de ubicaciones para obtener datos en tiempo real.
 *
 * @param {'airport' | 'airline'} type - Tipo de búsqueda: 'airport' o 'airline'
 * @returns {(keyword: string) => Observable<any[]>} - Función que recibe keyword y retorna Observable con resultados
 *
 * @uses ubicacionesService.getAirportsAirlines - Servicio para obtener datos de aeropuertos/aerolíneas
 *
 * @example
 * // Uso en componente de autocompletado:
 * const airportSource = this.getAutoCompleteSource('airport');
 * airportSource('hav').subscribe(results => {...});
 *
 * @example
 * // Uso con aerolíneas:
 * const airlineSource = this.getAutoCompleteSource('airline');
 * airlineSource('cub').subscribe(results => {...});
 */
  getAutoCompleteSource(type: 'airport' | 'airline'): (keyword: string) => Observable<any[]> {
    return (keyword: string) => {
      return this.ubicacionesService.getAirportsAirlines(keyword, type);
    };
  }

  /**
 * Función observable para fuentes de datos de autocompletado de aeropuertos/aerolíneas
 *
 * Este método proporciona una fuente de datos observable para componentes de búsqueda
 * que necesitan obtener sugerencias de aeropuertos o aerolíneas basadas en keywords.
 *
 * @param {string} keyword - Término de búsqueda ingresado por el usuario
 * @param {string} type - Tipo de búsqueda: 'airport' o 'airline'
 * @returns {Observable<any[]>} - Observable con array de resultados o error message
 *
 * @uses ubicacionesService.getAirportsAirlines - Servicio principal de búsqueda
 *
 * @errorHandling
 * - Si el servicio retorna undefined, captura el mensaje de error en errorMsg
 * - Retorna el observable del servicio o maneja el error apropiadamente
 *
 * @example
 * // Uso en componente:
 * this.observableSourceAirportAirline('miami', 'airport').subscribe(
 *   results => console.log(results),
 *   error => console.error(error)
 * );
 */
  observableSourceAirportAirline = (keyword: string, type: string): Observable<any[]> => {
    const results = this.ubicacionesService.getAirportsAirlines(keyword, type);
    if (results !== undefined) {
      return results;
    } else {
      this.errorMsg = results['message'];
    }
  }

  /**
 * Factory function que retorna una función de autocompletado para destinos (ciudades)
 *
 * Este método genera funciones de búsqueda para componentes de autocompletado que
 * se conectan con el servicio de ubicaciones para obtener datos de ciudades en tiempo real.
 *
 * @param {string} [keyoword] - Parámetro opcional (posible typo de 'keyword')
 * @returns {(keyword: string) => Observable<any[]>} - Función que recibe keyword y retorna Observable con resultados de ciudades
 *
 * @uses ubicacionesService.getCitys - Servicio para obtener datos de ciudades
 * @uses map() - Operador RxJS para transformar la respuesta
 *
 * @transformation
 * - Filtra la respuesta para encontrar el objeto con type === 'city'
 * - Retorna el array cities o un array vacío si no existe
 *
 * @example
 * // Uso en componente de autocompletado:
 * const citySource = this.getAutoCompleteSourceDestination();
 * citySource('hav').subscribe(cities => {...});
 */
  getAutoCompleteSourceDestination(keyoword?: string): (keyword: string) => Observable<any[]> {
    return (keyword: string) => {
      return this.ubicacionesService.getCitys(keyword).pipe(
        map((response: any) => {
          // Retorna solo el array hotels de la respuesta
          return response.find(r  => r.type === 'city')?.cities || []; // Usa array vacío si hotels no existe
        })
      );
    };
  }
/**
 * Formatea la visualización de destinos (ciudades) en listas desplegables
 *
 * Este método genera HTML seguro para mostrar información de ciudades en formatos
 * personalizados dentro de componentes de autocompletado o selección.
 *
 * @param {any} data - Objeto con los datos de la ciudad
 * @param {string} data.city_name - Nombre de la ciudad
 * @param {string} data.country_name - Nombre del país
 *
 * @returns {SafeHtml} - HTML sanitizado y seguro para renderizar
 *
 * @uses DomSanitizer.bypassSecurityTrustHtml - Para permitir HTML seguro
 *
 * @format
 * - Ícono de marcador de mapa (fa-map-marker)
 * - Nombre de la ciudad seguido de coma
 * - Nombre del país en negrita
 *
 * @example
 * // Retorna: HTML con "La Habana, Cuba"
 * this._myListFormatterDestination({
 *   city_name: 'La Habana',
 *   country_name: 'Cuba'
 * });
 */
    _myListFormatterDestination = (data: any) => {

      const html = `<span class='fa fa-map-marker'style='color:#a9a4a4'>
      </span>
      <span style='font-size:15px;cursor:pointer;line-height:2.1;'>
        ${ data['city_name']},
      </span>
      <span style=' font-weight: 500;font-size:14px;color:black'>
        ${data['country_name']}
      </span>`;

    return this._sanitizer.bypassSecurityTrustHtml(html);

  }


  /***********************************************Auto Complete********************************************/

  /**
 * Reinicia el formulario de vuelos a su estado inicial y limpia selecciones
 *
 * Este método restablece todos los controles del formulario y elimina las opciones
 * seleccionadas en los campos de aeropuertos y aerolíneas.
 *
 * @returns {void}
 *
 * @actions
 * 1. Resetea todos los valores del formulario _formFlights
 * 2. Limpia las selecciones de aeropuertos y aerolíneas mediante deleteSelectedOption
 *
 * @uses deleteSelectedOption() - Método para limpiar selecciones específicas
 *
 * @example
 * // Reiniciar formulario completo:
 * this.resetForm();
 */
  resetForm ()  {
    this._formFlights.reset();
    this.deleteSelectedOption('airportIn');
    this.deleteSelectedOption('airlineIn');
    this.deleteSelectedOption('airportOut');
    this.deleteSelectedOption('airlineOut');
  }

  /**
 * Inicializa el formulario de vuelos con configuraciones condicionales basadas en el contexto
 *
 * Este método configura dinámicamente el formulario de vuelos según diferentes escenarios:
 * - Transferencias one-way vs round-trip
 * - Vuelos de entrada only vs vuelos de salida only vs formulario completo
 * - Estados disabled para ciertos controles según el contexto
 *
 * @logic
 * Primero verifica si existe payloadSearch con categoría 8 (transfers):
 * - Configura formulario parcial para one-way transfers
 * - Configura formulario completo para round-trip transfers
 *
 * Si no hay payloadSearch, verifica flyShowComponent:
 * - Configura formulario parcial según vuelos existentes
 * - Configura formulario completo por defecto
 *
 * @uses subscribeFormCheckDatesIn() - Suscribe validaciones de fechas para vuelos de entrada
 * @uses subscribeFormCheckDatesOut() - Suscribe validaciones de fechas para vuelos de salida
 * @uses initFullForm() - Inicializa formulario completo con todos los controles
 *
 * @states
 * - onlyIn: true → Solo formulario de vuelo de entrada
 * - onlyOut: true → Solo formulario de vuelo de salida
 * - Ambos true → Formulario completo pero con controles disabled
 *
 * @disabledControls
 * Controles se deshabilitan según el tipo de transferencia o estado del vuelo
 */
    _initFlightsForm() {
      if(this.payloadSearch && this.payloadSearch[0].categoriesId[0] === 8) {

      //   const dataPreview: boolean = this._actualItinerary.flights && this._actualItinerary.flights.length > 0
      //                                 ? (this._actualItinerary.flights[0]?.arrivalIn || this._actualItinerary.flights[0]?.departureOut)
      //                                 ? true
      //                                 : false
      //                                 : false;

      //   if(this.payloadSearch[0].transfers.oneWay && !dataPreview) {

      //     if(this.payloadSearch[0].transfers.pickupLocation?.type === 'airport' && this.payloadSearch[0].transfers.dropoffLocation?.type !== 'airport') {

      //       this.onlyIn = true;
      //           this._formFlights = this._formBuilder.group({
      //         //in
      //         airlineIn: new FormControl(null, Validators.required),
      //         _flightNumberIn: new FormControl(null, Validators.required),
      //         flightNumberIn: new FormControl(null, [Validators.required, Validators.minLength(3)]),
      //         // cityDepartureIn: new FormControl(null, Validators.required),
      //         // departureDateIn: new FormControl(null, Validators.required),
      //         // departureHourIn: new FormControl(null, Validators.required),
      //         arrivalDateIn: new FormControl(null, Validators.required),
      //         arrivalHourIn: new FormControl(null, Validators.required),
      //         airportIn: new FormControl(null, Validators.required),



      //       });

      //        this.subscribeFormCheckDatesIn();

      //       this._formFlights.get('departureHourIn')?.disable();
      //       this._formFlights.get('arrivalHourIn')?.disable();

      //   } else if(this.payloadSearch[0].transfers.dropoffLocation?.type === 'airport' && this.payloadSearch[0].transfers.pickupLocation?.type !== 'airport') {

      //     this.onlyOut = true;
      //        this._formFlights = this._formBuilder.group({
      //          airlineOut: new FormControl(null, Validators.required),
      //         _flightNumberOut: new FormControl(null, Validators.required),
      //         flightNumberOut: new FormControl(null,[Validators.required, Validators.minLength(3)]),
      //         departureDateOut: new FormControl(null, Validators.required),
      //         // iataCityArrivalOut: new FormControl(null, Validators.required),
      //         departureHourOut: new FormControl(null, Validators.required),
      //         // arrivalDateOut: new FormControl(null, Validators.required),
      //         // arrivalHourOut: new FormControl(null, Validators.required),
      //         airportOut: new FormControl(null, Validators.required)
      //        });

      //       this.subscribeFormCheckDatesOut();

      //       this._formFlights.get('departureDateOut')?.disable();
      //       this._formFlights.get('departureHourOut')?.disable();
      //       this._formFlights.get('arrivalDateOut')?.disable();
      //       this._formFlights.get('arrivalHourOut')?.disable();

      //   } else {
      //      this.onlyIn = true;
      //    this.onlyOut = true;

      //    this.initFullForm();


      //      this.subscribeFormCheckDatesIn();
      //      this.subscribeFormCheckDatesOut();



      // this._formFlights.get('departureHourIn')?.disable();
      // this._formFlights.get('arrivalHourIn')?.disable();

      // this._formFlights.get('departureDateOut')?.disable();
      // this._formFlights.get('departureHourOut')?.disable();
      // this._formFlights.get('arrivalDateOut')?.disable();
      // this._formFlights.get('arrivalHourOut')?.disable();
      //   }
      // } else {
         this.onlyIn = true;
         this.onlyOut = true;

         this.initFullForm();


           this.subscribeFormCheckDatesIn();
           this.subscribeFormCheckDatesOut();



      this._formFlights.get('departureHourIn')?.disable();
      this._formFlights.get('arrivalHourIn')?.disable();

      this._formFlights.get('departureDateOut')?.disable();
      this._formFlights.get('departureHourOut')?.disable();
      this._formFlights.get('arrivalDateOut')?.disable();
      this._formFlights.get('arrivalHourOut')?.disable();
      // }
  } else {

      if(this.flyShowComponent?.fly && this.flyShowComponent?.fly?.arrivalDateIn && !this.flyShowComponent?.fly?.arrivalDateOut ) {
               this.onlyIn = true;
                this._formFlights = this._formBuilder.group({
              //in
              airlineIn: new FormControl(null, Validators.required),
              _flightNumberIn: new FormControl(null, Validators.required),
              flightNumberIn: new FormControl(null, [Validators.required, Validators.minLength(3)]),
              arrivalDateIn: new FormControl(null, Validators.required),
              arrivalHourIn: new FormControl(null, Validators.required),
              airportIn: new FormControl(null, Validators.required),


            });

             this.subscribeFormCheckDatesIn();

            this._formFlights.get('departureHourIn')?.disable();
            this._formFlights.get('arrivalHourIn')?.disable();
      }

      else if(this.flyShowComponent?.fly && this.flyShowComponent?.fly?.arrivalDateOut && !this.flyShowComponent?.fly?.arrivalDateIn) {
             this.onlyOut = true;
             this._formFlights = this._formBuilder.group({
               airlineOut: new FormControl(null, Validators.required),
              _flightNumberOut: new FormControl(null, Validators.required),
              flightNumberOut: new FormControl(null,[Validators.required, Validators.minLength(3)]),
              departureDateOut: new FormControl(null, Validators.required),
              departureHourOut: new FormControl(null, Validators.required),
              airportOut: new FormControl(null, Validators.required)
             });

            this.subscribeFormCheckDatesOut();

            this._formFlights.get('departureDateOut')?.disable();
            this._formFlights.get('departureHourOut')?.disable();
            this._formFlights.get('arrivalDateOut')?.disable();
            this._formFlights.get('arrivalHourOut')?.disable();

      } else {
      this.onlyIn = true;
      this.onlyOut = true;
        this.initFullForm();

        if(this._actualItinerary?.flights?.length === 0) {
          this._formFlights.get('departureHourIn')?.disable();
          this._formFlights.get('arrivalHourIn')?.disable();
          this._formFlights.get('departureDateOut')?.disable();
          this._formFlights.get('departureHourOut')?.disable();
          this._formFlights.get('arrivalDateOut')?.disable();
          this._formFlights.get('arrivalHourOut')?.disable();
          this.subscribeFormCheckDatesIn();
          this.subscribeFormCheckDatesOut();
        } else {
          setTimeout(() => {
            this.subscribeFormCheckDatesIn();
            this.subscribeFormCheckDatesOut();
          }, 800);
        }




      }

  }
  }

  /**
 * Inicializa el formulario completo de vuelos con todos los controles y validaciones
 *
 * Este método crea el formulario reactivo con todos los campos necesarios para
 * vuelos de ida y vuelta (round-trip) con sus respectivas validaciones.
 *
 * @returns {void}
 *
 * @structure
 * Grupo de controles para vuelo de entrada (in):
 * - airlineIn: Aerolínea de entrada (requerido)
 * - _flightNumberIn: Número de vuelo interno (requerido)
 * - flightNumberIn: Número de vuelo (requerido, min 3 caracteres)
 * - cityDepartureIn: Ciudad de salida (requerido)
 * - departureDateIn: Fecha de salida (requerido)
 * - departureHourIn: Hora de salida (requerido)
 * - arrivalDateIn: Fecha de llegada (requerido)
 * - arrivalHourIn: Hora de llegada (requerido)
 * - airportIn: Aeropuerto de entrada (requerido)
 *
 * Grupo de controles para vuelo de salida (out):
 * - airlineOut: Aerolínea de salida (requerido)
 * - _flightNumberOut: Número de vuelo interno (requerido)
 * - flightNumberOut: Número de vuelo (requerido, min 3 caracteres)
 * - iataCityArrivalOut: Ciudad de llegada IATA (requerido)
 * - departureDateOut: Fecha de salida (requerido)
 * - departureHourOut: Hora de salida (requerido)
 * - arrivalDateOut: Fecha de llegada (requerido)
 * - arrivalHourOut: Hora de llegada (requerido)
 * - airportOut: Aeropuerto de salida (requerido)
 *
 * @validations
 * - Todos los campos son requeridos
 * - flightNumberIn/Out tienen validación de longitud mínima (3 caracteres)
 *
 * @example
 * // Inicializar formulario completo:
 * this.initFullForm();
 */
  initFullForm(): void {
   this._formFlights = this._formBuilder.group({
      //in
      airlineIn: new FormControl(null, Validators.required),
      _flightNumberIn: new FormControl(null, Validators.required),
      flightNumberIn: new FormControl(null, [Validators.required, Validators.minLength(3)]),
      arrivalDateIn: new FormControl(null, Validators.required),
      arrivalHourIn: new FormControl(null, Validators.required),
      airportIn: new FormControl(null, Validators.required),
      //out
      airlineOut: new FormControl(null, Validators.required),
      _flightNumberOut: new FormControl(null, Validators.required),
      flightNumberOut: new FormControl(null,[Validators.required, Validators.minLength(3)]),
      departureDateOut: new FormControl(null, Validators.required),
      departureHourOut: new FormControl(null, Validators.required),
      airportOut: new FormControl(null, Validators.required)
   })
  }

  /**
 * Parchea el formulario de vuelos con datos existentes de un vuelo
 *
 * Este método complejo llena el formulario con datos de un vuelo existente, manejando
 * múltiples escenarios según el contexto (results vs fly) y origen de los datos.
 *
 * @param {any} [infoFly] - Objeto opcional con información del vuelo a editar
 * @returns {void}
 *
 * @contexts
 * - Si component === 'results': Usa flight del itinerario actual
 * - Si component === 'fly': Usa infoFly proporcionado
 *
 * @scenarios
 * 1. Edición de vuelo existente (con flight.id):
 *    - Completa todos los campos del formulario con datos del vuelo
 *    - Realiza búsquedas adicionales para información de ciudades
 *    - Configura fechas y horas con parsing especializado
 *
 * 2. Nuevo vuelo con datos de transfers (payloadSearch):
 *    - Prellena campos basado en información de transfers
 *    - Configura fechas basado en firstArrivalDate de transfers
 *    - Ajusta tiempos restando 1 minuto para validaciones
 *
 * @operations
 * - Setea valores en controles del formulario
 * - Actualiza propiedades del componente (selectedAirportIn, etc.)
 * - Realiza llamadas a servicios para obtener datos de ciudades
 * - Parsea y formatea fechas y horas
 * - Maneja escenarios oneWay vs round-trip
 *
 * @uses parseLocalDateTime() - Para parsing de fechas desde strings
 * @uses _extractHourMinute() - Para extraer hora de objetos Date
 * @uses ubicacionesService.getCitys() - Para búsqueda de información de ciudades
 *
 * @sideEffects
 * - Actualiza multiple properties del componente
 * - Realiza suscripciones a observables
 * - Ejecuta change detection manualmente
 */
  patchForm(infoFly?: any): void {
    let flight: any;
    this.maxDateDepartureDateIn = null;
      if(this.component === 'results') {
        flight = this._actualItinerary?.flights[0];
      } else if(this.component === 'fly') {
        flight = infoFly;
      }

    if(flight && flight?.id) {
        //airportIn
          this.onlyIn = true;
          this.onlyOut = true;




        //othersDates

        if(flight?.arrivalIn) {
        this.selectedAirportIn = flight?.airportIataCodeIn;
        this.selectedAirportInCountryCode = flight?.iata_code;
        this.selectedAirportInId = flight?.id_airport;
        this._formFlights.get('airportIn')?.setValue({name: flight.airportIn});
        //airlineIn
        this._formFlights.get('airlineIn')?.setValue({name: flight?.airlineIn, iata: flight?.airlineIataCodeIn});
        this.selectedAirlineInName = flight?.airlineIn;
        const departureIn = this.parseLocalDateTime(flight?.departureIn);
        const arrivalIn = this.parseLocalDateTime(flight?.arrivalIn);
          this._formFlights.patchValue({
            _flightNumberIn: flight?.airlineIataCodeIn ? flight?.airlineIataCodeIn: null,
            flightNumberIn: flight.flyNumberIn ? flight.flyNumberIn : null,
            departureHourIn: departureIn ? this._extractHourMinute(departureIn.toString()) : null,

          })
            this._formFlights.patchValue({
              arrivalDateIn: arrivalIn ? arrivalIn : null,
              arrivalHourIn: arrivalIn ? this._extractHourMinute(arrivalIn.toString()) : null,
            })
        }

        if(flight?.departureOut) {
              const departureOut = this.parseLocalDateTime(flight?.departureOut);
              const arrivalOut = this.parseLocalDateTime(flight?.arrivalOut);
              this.selectedAirportOut = flight?.airportIataCodeOut;
              this._formFlights.get('airportOut')?.setValue({name: flight?.airportOut, iata: flight?.airportIataCodeOut});
              // airlineOut
               this._formFlights.get('airlineOut')?.setValue({name: flight?.airlineOut, iata: flight?.airlineIataCodeOut});
               this.selectedAirlineOutName = flight?.airlineOut;
               this._formFlights.patchValue({
                 // out
                 _flightNumberOut: flight?.airlineIataCodeOut ? flight?.airlineIataCodeOut: null,
                 flightNumberOut: flight.flyNumberOut ? flight.flyNumberOut : null,
                 departureDateOut: departureOut ? departureOut : null,
                 departureHourOut: departureOut? this._extractHourMinute(departureOut.toString()) : null,


                });

                 this._formFlights.patchValue({

                arrivalDateOut: arrivalOut ? arrivalOut : null,
                arrivalHourOut: arrivalOut ? this._extractHourMinute(arrivalOut.toString()) : null,

              });
        }
    } else {
          if(
            this.payloadSearch &&
            this.payloadSearch.length > 0 &&
            this.formTransports
          ) {
              if (this.payloadSearch[0].transfers?.pickupLocation?.type === 'airport') {
                this.selectedAirportIn = this.payloadSearch[0].transfers?.pickupLocation?.address || null;
                this.selectedAirportInCountryCode = this.formTransports?.firstOrigin?.country_code || null;
                this.selectedAirportInId = this.payloadSearch[0].transfers?.pickupLocation?.id || null;
                this._formFlights.get('airportIn').setValue({ name: this.formTransports?.firstOrigin?.name || null });

                const originalDate = new Date(this.formTransports?.firstArrivalDate);
                const [hours, minutes] = this.formTransports.firstTime?.split(':') || ['00', '00'];
                originalDate.setHours(parseInt(hours, 10));
                originalDate.setMinutes(parseInt(minutes, 10));

                // ✅ Restar 1 minuto
                originalDate.setMinutes(originalDate.getMinutes() - 1);

                // Extraer los nuevos valores
                const newDepartureDate = new Date(originalDate); // solo la fecha (sin hora para el datepicker)
                const newDepartureHour = originalDate.toTimeString().split(':').slice(0, 2).join(':'); // hh:mm

                this._formFlights.patchValue({
                  arrivalDateIn: newDepartureDate,
                  arrivalHouInt: `${newDepartureHour}:00`,
                });
              }


            if(this.payloadSearch[0].transfers?.dropoffLocation?.type === 'airport') {

              if(this.payloadSearch[0].transfers?.pickupLocation?.type !== 'airport') {
                 this.selectedAirportInCountryCode = this.formTransports?.firstDestination?.country_code || null;
                this.selectedAirportInId = this.payloadSearch[0].transfers?.dropoffLocation?.id || null;
              }
              this.selectedAirportOut = this.payloadSearch[0].transfers?.dropoffLocation?.address ? this.payloadSearch[0].transfers?.dropoffLocation?.address : null;

              this._formFlights.get('airportOut').setValue({name: this.formTransports?.firstDestination.name ? this.formTransports?.firstDestination.name : null});

                const originalDate = new Date(this.formTransports?.firstArrivalDate);
                const [hours, minutes] = this.formTransports?.firstTime?.split(':') || ['00', '00'];
                originalDate.setHours(parseInt(hours, 10));
                originalDate.setMinutes(parseInt(minutes, 10));

                // ✅ Restar 1 minuto
                originalDate.setMinutes(originalDate.getMinutes() - 1);

                // Extraer los nuevos valores
                const newDepartureDate = new Date(originalDate); // solo la fecha (sin hora para el datepicker)
                const newDepartureHour = originalDate.toTimeString().split(':').slice(0, 2).join(':'); // hh:mm

                this._formFlights.patchValue({
                  arrivalDateOut: newDepartureDate,
                  arrivalHourOut: `${newDepartureHour}:00`,
                });
              this._formFlights.patchValue({
                departureDateOut: this.payloadSearch[0]?.dropoffDate ? new Date(this.payloadSearch[0]?.dropoffDate) : null,
                departureHourOut: this.formTransports?.firstArrivalDate ? this._extractHourMinute(this.formTransports?.firstArrivalDate) : null,
                // arrivalDateOut: this.payloadSearch[0]?.dropoffDate ? new Date(this.payloadSearch[0]?.dropoffDate) : null,
                // arrivalHourOut: this.formTransports?.firstArrivalDate ? this._extractHourMinute(this.formTransports?.firstArrivalDate) : null,
              });
            }
          }

    }
    this.cdr.detectChanges();
  }

  /**
 * Parsea un string de fecha-hora en formato ISO a objeto Date local
 *
 * Este método utility convierte strings en formato ISO 8601 (YYYY-MM-DDTHH:mm:ssZ)
 * a objetos Date, manejando correctamente la zona horaria local.
 *
 * @param {string} dateTimeStr - String de fecha-hora en formato ISO
 * @returns {Date} - Objeto Date correspondiente o undefined si el string es inválido
 *
 * @parsing
 * 1. Divide en parte de fecha y parte de tiempo
 * 2. Remueve 'Z' (UTC) y milisegundos si están presentes
 * 3. Convierte cada componente a números
 * 4. Crea nuevo Date con componentes específicos
 *
 * @example
 * // Retorna: Date object para 2023-12-25 15:30:00 en zona local
 * this.parseLocalDateTime('2023-12-25T15:30:00Z');
 *
 * @note
 * - Meses se ajustan (-1) porque JavaScript months son 0-based
 * - Maneja strings con o sin milisegundos
 * - Ignora información de zona horaria, trata como hora local
 */
private parseLocalDateTime(dateTimeStr: string): Date {
  if(!dateTimeStr) {
    return;
  }
  const [datePart, timePartRaw] = dateTimeStr.split('T');
  if (!datePart || !timePartRaw) return null;

  const [year, month, day] = datePart.split('-').map(Number);

  const timePart = timePartRaw.replace('Z', '').split('.')[0]; // elimina "Z" y milisegundos
  const [hour, minute, second] = timePart.split(':').map(Number);

  return new Date(year, month - 1, day, hour, minute, second);
}

/**
 * Extrae la hora y minutos de un objeto Date en formato HH:mm:00
 *
 * Este método utility formatea la parte de tiempo de un objeto Date
 * a string en formato de 24 horas con segundos establecidos a '00'.
 *
 * @param {string} dateTime - String representando una fecha/hora
 * @returns {string} - Hora formateada como "HH:mm:00"
 *
 * @format
 * - Horas: 2 dígitos con leading zeros
 * - Minutos: 2 dígitos con leading zeros
 * - Segundos: siempre "00"
 *
 * @example
 * // Retorna: "15:30:00"
 * this._extractHourMinute('2023-12-25T15:30:45Z');
 *
 * @uses
 * - getHours(): Obtiene horas (0-23)
 * - getMinutes(): Obtiene minutos (0-59)
 * - padStart(2, '0'): Asegura 2 dígitos
 */
  private _extractHourMinute(dateTime: string): string {
    const date = new Date(dateTime);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  /**
 * Suscribe y gestiona las validaciones y habilitación condicional de campos de fecha/hora para vuelos de entrada
 *
 * Este método configura un sistema de dependencias entre campos donde la habilitación de cada campo
 * depende de que el campo anterior tenga un valor válido. Además, aplica debounce para optimizar el rendimiento.
 *
 * @dependencies
 * - departureHourIn → depende de → departureDateIn
 * - arrivalDateIn → depende de → departureDateIn + departureHourIn
 * - arrivalHourIn → depende de → arrivalDateIn
 * - departureDateOut → depende de → arrivalDateIn
 *
 * @actions
 * 1. Habilita/deshabilita campos basado en dependencias
 * 2. Resetea campos dependientes cuando se deshabilitan
 * 3. Actualiza fechas mínimas para campos relacionados
 * 4. Aplica validaciones de coherencia temporal
 *
 * @uses debounceTime(750) - Optimiza rendimiento evitando múltiples ejecuciones
 * @uses distinctUntilChanged() - Evita procesamiento duplicado con mismos valores
 *
 * @sideEffects
 * - Actualiza minDateArrivalOut para validaciones cruzadas
 * - Ejecuta updateMinArrivalInHour() y validateArrivalHourIn()
 */
  subscribeFormCheckDatesIn(): void {
    const checkEnableArrivalInFields = () => {

    const arrivalDateIn = this._formFlights.get('arrivalDateIn')?.value;
    const hourDateIn = this._formFlights.get('arrivalHourIn')?.value;

      // 1. arrivalHourIn depende de arrivalDateIn
      if (arrivalDateIn) {
        this.minDateArrivalOut = new Date(arrivalDateIn);
        this.minDateArrivalOut = new Date(this.minDateArrivalOut.getTime()); // Fuerza nueva instancia
        this._formFlights.get('arrivalHourIn')?.enable({ emitEvent: false });
        this._formFlights.get('departureDateOut')?.enable({ emitEvent: false });
      } else {
        this._formFlights.get('arrivalHourIn')?.disable({ emitEvent: false });
        // this._formFlights.get('arrivalHourIn')?.reset(null, { emitEvent: false });; // Opcional
        this._formFlights.get('departureDateOut')?.disable({ emitEvent: false });
        // this._formFlights.get('departureDateOut')?.reset(null, { emitEvent: false });; // Opcional
      }

      if (arrivalDateIn && hourDateIn) {
        this._formFlights.get('departureHourOut')?.enable({ emitEvent: false });
      }

    };

 // Configuración reusable del debounce
  const debounceConfig = (time: number = 750) =>
    pipe(debounceTime(time), distinctUntilChanged());

  this._formFlights.get('arrivalDateIn')?.valueChanges
    .pipe(debounceConfig(), takeUntil(this.destroy$))
    .subscribe(() => {
      checkEnableArrivalInFields();
    });

  this._formFlights.get('arrivalHourIn')?.valueChanges
    .pipe(debounceConfig(), takeUntil(this.destroy$))
    .subscribe(() => {
      checkEnableArrivalInFields();
      this.validateArrivalHourIn();
    });
  }


/**
 * Valida que la hora de llegada sea coherente con la hora actual del sistema
 * y con la hora de salida cuando aplica
 *
 * @validation
 * - arrivalHourIn no puede ser menor a la hora actual del sistema
 * - Cuando departureDateIn y arrivalDateIn son el mismo día:
 * - Si arrivalHourIn es anterior, se corrige automáticamente
 *
 * @actions
 * 1. Valida contra hora actual del sistema
 * 3. Corrige valores inválidos automáticamente
 * 4. Muestra toast de advertencia al usuario
 */
validateArrivalHourIn(): void {
  const arrivalDate = this._formFlights.get('arrivalDateIn')?.value;
  const arrivalHour = this._formFlights.get('arrivalHourIn')?.value;

  if (arrivalDate && arrivalHour) {
    try {
      // Manejar tanto string como objeto Date
      const dateObj = new Date(arrivalDate);
      const dateString = moment(dateObj).format('YYYY-MM-DD');

      const currentMoment = moment();
      const arrivalMoment = moment(`${dateString} ${arrivalHour}`, 'YYYY-MM-DD HH:mm');

      if (!arrivalMoment.isValid()) {
        console.error('Fecha/hora inválida:', dateString, arrivalHour);
        return;
      }

      if (arrivalMoment.isBefore(currentMoment)) {
        const correctedTime = currentMoment.clone().add(1, 'minutes');
        const formatted = correctedTime.format('HH:mm');
        this._formFlights.get('arrivalHourIn')?.setValue(formatted, { emitEvent: false });
        this.toastr.warning('El horario de llegada no puede ser menor a la hora actual.');
      }
    } catch (error) {
      console.error('Error en validación de hora:', error);
    }
  }
}


/**
 * Formatea un objeto Date a string en formato HH:mm con 2 dígitos
 *
 * Este método utility convierte la parte horaria de un objeto Date
 * a un string formateado con horas y minutos de 2 dígitos cada uno.
 *
 * @param {Date} date - Objeto Date a formatear
 * @returns {string} - Hora formateada como "HH:mm" (ej: "09:05", "14:30")
 *
 * @format
 * - Horas: 2 dígitos con leading zero (00-23)
 * - Minutos: 2 dígitos con leading zero (00-59)
 *
 * @uses
 * - getHours(): Obtiene horas del Date (0-23)
 * - getMinutes(): Obtiene minutos del Date (0-59)
 * - padStart(2, '0'): Asegura 2 dígitos con leading zeros
 *
 * @example
 * // Retorna: "09:05"
 * this.formatTime(new Date(2023, 11, 25, 9, 5));
 *
 * @example
 * // Retorna: "14:30"
 * this.formatTime(new Date(2023, 11, 25, 14, 30));
 */
  formatTime(date: Date): string {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  /**
 * Suscribe y gestiona las validaciones y habilitación condicional de campos de fecha/hora para vuelos de salida
 *
 * Este método configura un sistema de dependencias entre campos para vuelos de salida (out)
 * donde la habilitación de cada campo depende de que el campo anterior tenga un valor válido.
 * Aplica debounce para optimizar el rendimiento y prevenir procesamiento excesivo.
 *
 * @dependencies
 * - departureHourOut → depende de → departureDateOut
 * - arrivalDateOut → depende de → departureDateOut + departureHourOut
 * - arrivalHourOut → depende de → arrivalDateOut
 *
 * @actions
 * 1. Habilita/deshabilita campos basado en dependencias en cadena
 * 2. Resetea campos dependientes cuando se deshabilitan
 * 3. Aplica validaciones de coherencia temporal
 * 4. Optimiza con debounce para mejor rendimiento
 *
 * @uses debounceTime(750) - Evita múltiples ejecuciones en escritura rápida
 * @uses distinctUntilChanged() - Previene procesamiento con valores duplicados
 *
 * @sideEffects
 * - Ejecuta updateMinArrivalOutHour() para calcular mínimos
 * - Ejecuta validateArrivalHourOut() para validaciones
 */
  subscribeFormCheckDatesOut(): void {
    const checkEnableArrivalOutFields = () => {

      const arrivalDateIn = this._formFlights.get('arrivalDateIn')?.value;
      const hourDateIn = this._formFlights.get('arrivalHourIn')?.value;

      // 1. departureHourIn depende de departureDateIn
      if (arrivalDateIn && hourDateIn) {
        this._formFlights.get('departureHourOut')?.enable({ emitEvent: false });
      } else {
        this._formFlights.get('departureHourOut')?.disable({ emitEvent: false });
        this._formFlights.get('departureHourOut')?.reset(null, { emitEvent: false });; // Opcional: para limpiar el campo
      }
    };

      const debounceConfig = (time: number = 750) =>
    pipe(debounceTime(time), distinctUntilChanged());


  this._formFlights.get('departureDateOut')?.valueChanges
    .pipe(debounceConfig(), takeUntil(this.destroy$))
    .subscribe(() => {
      checkEnableArrivalOutFields();
    });

  this._formFlights.get('departureHourOut')?.valueChanges
    .pipe(debounceConfig(), takeUntil(this.destroy$))
    .subscribe(() => {
       checkEnableArrivalOutFields();
      this.validateDepartureHourOut();
    });


  }

/**
 * Calcula y establece la hora mínima permitida para la llegada de vuelos de salida
 *
 * Este métod
/**
 * Valida que la hora de llegada de salida sea coherente con la hora de salida
 *
 * Este método compara las horas de salida y llegada para vuelos de salida cuando
 * ocurren en el mismo día y asegura que la hora de llegada no sea anterior a la
 * hora de salida, corrigiendo automáticamente y notificando al usuario.
 *
 * @validation
 * - Solo aplica cuando departureDateOut y arrivalDateOut son el mismo día
 * - arrivalHourOut debe ser posterior a departureHourOut
 * - Si es anterior, se corrige a departureHourOut + 1 minuto
 *
 * @actions
 * 1. Compara fechas usando moment.js para consistencia
 * 2. Si arrivalHourOut es anterior, calcula corrección
 * 3. Setea valor corregido en el formulario
 * 4. Muestra advertencia al usuario via toastr
 *
 * @uses moment.js - Para parsing y comparación precisa
 * @uses toastr.warning() - Para notificación de usuario
 *
 * @example
 * // Si departureHourOut = "16:45" y arrivalHourOut = "16:40"
 * // Se corrige a "16:46" y muestra advertencia
 */
validateDepartureHourOut(): void {
  const arrivalDate = this._formFlights.get('arrivalDateIn')?.value;
  const arrivalHour = this._formFlights.get('arrivalHourIn')?.value;
  const departureDate = this._formFlights.get('departureDateOut')?.value;
  const departureHour = this._formFlights.get('departureHourOut')?.value;

  if (arrivalDate && arrivalHour && departureDate && departureHour) {
    try {
      // Convertir fechas a formato YYYY-MM-DD
      const arrivalDateObj = new Date(arrivalDate);
      const arrivalDateString = moment(arrivalDateObj).format('YYYY-MM-DD');

      const departureDateObj = new Date(departureDate);
      const departureDateString = moment(departureDateObj).format('YYYY-MM-DD');

      // Crear momentos para comparación
      const arrivalMoment = moment(`${arrivalDateString} ${arrivalHour}`, 'YYYY-MM-DD HH:mm');
      const departureMoment = moment(`${departureDateString} ${departureHour}`, 'YYYY-MM-DD HH:mm');

      if (!arrivalMoment.isValid() || !departureMoment.isValid()) {
        console.error('Fechas/horas inválidas:', arrivalDateString, arrivalHour, departureDateString, departureHour);
        return;
      }

      // Solo comparar si las fechas son iguales
      if (arrivalDateString === departureDateString) {
        if (departureMoment.isBefore(arrivalMoment)) {
          const correctedTime = arrivalMoment.clone().add(1, 'minutes');
          const formatted = correctedTime.format('HH:mm');
          this._formFlights.get('departureHourOut')?.setValue(formatted, { emitEvent: false });
          this.toastr.warning('El horario de salida no puede ser menor al horario de llegada.');
        }
      }
    } catch (error) {
      console.error('Error en validación de hora de salida:', error);
    }
  }
}

/**
 * Alterna el modo de visualización de hora entre formato 12h y 24h
 *
 * Este método cambia el estado de `ismeridian` que controla si los selectores de hora
 * deben mostrar formato meridiano (AM/PM) o formato 24 horas.
 *
 * @returns {void}
 *
 * @state
 * - ismeridian = true → Formato 12h con AM/PM
 * - ismeridian = false → Formato 24h militar
 *
 * @example
 * // Alternar de 24h a 12h:
 * this.toggleMode(); // ismeridian cambia de false a true
 *
 * @usage
 * Normalmente usado en conjunction con componentes de selección de hora
 */
  toggleMode(): void {
    this.ismeridian = !this.ismeridian;
  }

  /**
 * Cierra el modal actual ocultándolo de la vista
 *
 * Este método proporciona una forma de cerrar el modal activo mediante
 * la referencia almacenada en `modalRef`.
 *
 * @returns {void}
 *
 * @uses modalRef.hide() - Método de Bootstrap para ocultar modales
 *
 * @example
 * // Cerrar modal desde template:
 * <button (click)="cancel()">Cancelar</button>
 */
  cancel() {
    this.modalRef.hide();
  }

/**
 * Trunca una cadena a 18 caracteres si excede la longitud máxima
 *
 * Este método utility previene visualizaciones muy largas recortando
 * strings que superan los 18 caracteres, agregando "..." implícitamente.
 *
 * @param {string} str - Cadena a truncar
 * @returns {string} - Cadena original o truncada a 18 caracteres
 *
 * @limit
 * - Máximo 18 caracteres
 * - No agrega ellipsis (...) explícitamente
 *
 * @example
 * // Retorna: "Este es un texto mu"
 * this.subStrings("Este es un texto muy largo");
 *
 * @example
 * // Retorna: "Texto corto"
 * this.subStrings("Texto corto");
 */
  subStrings(str){
    if(str.length>18){
      return str.slice(0,18)
    }else{
      return str
    }
  }
/**
 * Convierte una cadena a formato de título (Title Case)
 *
 * Este método convierte todo el texto a minúsculas y luego capitaliza
 * la primera letra de cada palabra, implementando formato de título proper.
 *
 * @param {string} str - Cadena a convertir
 * @returns {string} - Cadena en Title Case
 *
 * @transformation
 * 1. Convierte toda la cadena a minúsculas
 * 2. Capitaliza la primera letra de cada palabra
 *
 * @uses regex /\b\w/g - Encuentra el primer caracter de cada palabra
 *
 * @example
 * // Retorna: "Juan Pérez García"
 * this.stingUpperCase("juan pérez garcía");
 *
 * @example
 * // Retorna: "New York City"
 * this.stingUpperCase("NEW YORK CITY");
 */
  stingUpperCase(str){
    let e = str.toLowerCase()
    return e.replace(/\b\w/g, l => l.toUpperCase())
  }

  /**
 * Elimina la opción seleccionada de un campo específico y limpia propiedades relacionadas
 *
 * Este método proporciona una forma centralizada de resetear campos del formulario
 * y sus propiedades asociadas según el tipo de campo especificado.
 *
 * @param {string} type - Tipo de campo a limpiar
 * @returns {void}
 *
 * @supportedTypes
 * - 'airportIn': Aeropuerto de entrada
 * - 'airlineIn': Aerolínea de entrada
 * - 'airportOut': Aeropuerto de salida
 * - 'airlineOut': Aerolínea de salida
 * - 'cityDepartureIn': Ciudad de salida
 * - 'iataCityArrivalOut': Ciudad de llegada IATA
 *
 * @actions
 * - Resetea el valor del control del formulario
 * - Limpia propiedades del componente relacionadas
 * - Maneja casos especiales para transfers con categoría 8
 *
 * @specialCase
 * Para 'airportOut' con transfers específicos, también limpia propiedades de aeropuerto de entrada
 */
  deleteSelectedOption(type: string): void {

    switch(type) {
      case 'airportIn':
        this._formFlights.get('airportIn')?.setValue('');
        this.selectedAirportIn = '';
        this.selectedAirportInId = undefined;
        this.selectedAirportInCountryCode = undefined;
        break;
      case 'airlineIn':
        this._formFlights.get('airlineIn')?.setValue(null);
        this._formFlights.get('_flightNumberIn')?.setValue(null);
        this.selectedAirlineIn = '';
        this.valueAirlineCodeIata = undefined;
        this.selectedAirlineInName = '';
        break;
      case 'airportOut':
        this._formFlights.get('airportOut')?.setValue('');
            if(this.payloadSearch && this.payloadSearch[0].categoriesId[0] === 8 &&
            this.payloadSearch[0].transfers.pickupLocation.type !== 'airport' &&
            this.payloadSearch[0].transfers.dropoffLocation.type === 'airport') {
                  this.selectedAirportInId = undefined;
              this.selectedAirportInCountryCode = undefined;
          }
        this.selectedAirportOut = '';
        break;
      case 'airlineOut':
          this._formFlights.get('airlineOut')?.setValue(null);
          this._formFlights.get('_flightNumberOut')?.setValue(null);
          this.selectedAirlineOut = undefined;
          this.selectedAirlineOutName = '';
        break;
      default:
        break;
    }
  }

  /**
   * Clears a date form control (and resets its touched state).
   * Does NOT clear the related time field — the time will be visually disabled
   * because the input is bound to disabled state based on the date being present.
   * @param controlName 'arrivalDateIn' or 'departureDateOut'
   */
  _clearDate(controlName: 'arrivalDateIn' | 'departureDateOut'): void {
    const fc = this._formFlights.get(controlName);
    if (fc) {
      fc.setValue(null);
      fc.markAsUntouched();
    }
    // Close any open time picker for safety
    this.activeTimePicker = null;
  }

  /**
 * Extrae la hora de un string de fecha-hora en formato ISO
 *
 * Este método utility extrae la parte horaria (HH:MM) de un string
 * en formato ISO 8601 mediante slicing de posiciones fijas.
 *
 * @param {string} dateTime - String de fecha-hora en formato ISO (YYYY-MM-DDTHH:MM:SS)
 * @returns {string} - Hora en formato "HH:MM" o string vacío si no hay fecha
 *
 * @formatAssumption
 * - Asume formato ISO: "YYYY-MM-DDTHH:MM:SS"
 * - Extrae caracteres 11-16: "HH:MM"
 *
 * @example
 * // Retorna: "14:30"
 * this.getHourFly("2023-12-25T14:30:45Z");
 *
 * @example
 * // Retorna: ""
 * this.getHourFly(null);
 */
  getHourFly(dateTime: any): string {
      if (dateTime) {
        return dateTime.slice(11, 16); // 'HH:MM' empieza en el índice 11
      }
      return '';
   }

   /**
 * Calcula y formatea la diferencia de tiempo entre dos fechas de vuelo
 *
 * Este método calcula la diferencia entre la fecha de llegada de un vuelo de entrada
 * y la fecha de salida de un vuelo de salida, formateando el resultado para display.
 *
 * @param {string} dateFlyIn - Fecha de llegada del vuelo de entrada (ISO string)
 * @param {string} dateFlyOut - Fecha de salida del vuelo de salida (ISO string)
 * @returns {string} - Diferencia formateada como "(+X días)" o "(+HH:MM hs.)"
 *
 * @format
 * - Diferencia > 24 horas: "(+X día[s])"
 * - Diferencia < 24 horas: "(+HH:MM hs.)"
 *
 * @calculation
 * - Convierte strings a objetos Date
 * - Calcula diferencia en milisegundos
 * - Convierte a días, horas y minutos
 *
 * @example
 * // Retorna: "(+2 días)"
 * this.afterDateFlyOut("2023-12-25T14:30:00Z", "2023-12-27T10:00:00Z");
 *
 * @example
 * // Retorna: "(+03:45 hs.)"
 * this.afterDateFlyOut("2023-12-25T14:30:00Z", "2023-12-25T18:15:00Z");
 */
   afterDateFlyOut(dateFlyIn: string, dateFlyOut: string): string {
    const inDate = new Date(dateFlyIn);
    const outDate = new Date(dateFlyOut);

    // Diferencia en milisegundos
    const diffTime = outDate.getTime() - inDate.getTime();

    // Convertimos la diferencia a días, horas y minutos
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    const diffHours = Math.floor((diffTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const diffMinutes = Math.floor((diffTime % (1000 * 60 * 60)) / (1000 * 60));

    if (diffDays > 0) {
        return `(+${diffDays} día${diffDays > 1 ? 's' : ''})`;
    } else {
        return `(+${diffHours}:${diffMinutes.toString().padStart(2, '0')} hs.)`;
    }
}

/**
 * Controla la visibilidad del tooltip de vuelo y aplica filtros de color cuando se muestra
 *
 * Este método gestiona el estado de visualización del tooltip y cuando se activa (event = true),
 * aplica filtros CSS personalizados a los íconos basados en el color configurado para vuelos.
 *
 * @param {boolean} event - Estado de visibilidad del tooltip (true = visible, false = oculto)
 * @returns {void}
 *
 * @actions
 * - Actualiza el estado de tooltipFlight
 * - Cuando se muestra (event = true), ejecuta applyImageFilter()
 *
 * @sideEffects
 * - Modifica tooltipFlight con el nuevo estado
 * - Ejecuta applyImageFilter() que modifica estilos CSS de íconos
 *
 * @example
 * // Mostrar tooltip y aplicar filtros:
 * this.changeTooltipFlightVisible(true);
 *
 * // Ocultar tooltip:
 * this.changeTooltipFlightVisible(false);
 */
changeTooltipFlightVisible(event: boolean): void {
  if(event) {
     this.applyImageFilter();
  }

  this.tooltipFlight = event;
}

     /**
 * Aplica filtros CSS personalizados a íconos basados en el color de vuelo configurado
 *
 * Este método convierte un color hexadecimal a filtros CSS equivalentes y los aplica
 * a los íconos de vuelo, específicamente al primero y último ícono de la lista.
 *
 * @returns {void}
 *
 * @process
 * 1. Convierte hex color a filtros CSS usando CssFilterConverter
 * 2. Extrae y formatea los filtros de color
 * 3. Aplica los filtros a los íconos con setTimeout para evitar conflictos de renderizado
 *
 * @uses CssFilterConverter.hexToFilter() - Conversor de hex a filtros CSS
 * @uses setTimeout(0) - Para aplicar estilos después del ciclo de renderizado actual
 *
 * @targetElements
 * - Primer ícono (index = 0)
 * - Último ícono (index = icons.length - 1)
 *
 * @styling
 * - filter: Aplica los filtros de color convertidos
 * - width: 40px - Establece ancho fijo para los íconos
 *
 * @dependencies
 * - Requiere this.colorFlight configurado con color hexadecimal
 * - Requiere this.icons con referencias a elementos DOM
 */
    applyImageFilter() {
      const color = this.colorFlight;
      const tempFilterObj = CssFilterConverter.hexToFilter(color, { sheen: false });

      //Extraemos el literal en String de la conversión
      const tempFilterStr = Object.keys(tempFilterObj).map(key => `${key}(${tempFilterObj[key]})`).join(" ");

      // Convierte el color a un objeto de filtro de CSS y extrae los filtros de la respuesta color del resultado.
      const colorRegex = /color\((.*)\)/;
      const colorMatch = tempFilterStr.match(colorRegex);
      const colorFilter = colorMatch ? colorMatch[1] : "";

      const filter = colorFilter;

      // Establece el atributo de estilo "filter" en el elemento de imagen con los filtros de color extraídos.
      setTimeout(() => {

        this.icons.forEach(((icon, index) => {
          if(index === 0 || index === this.icons.length - 1) {
            icon.nativeElement.setAttribute('style', `filter: ${filter}; width: 40px;`);
          }
        }));
      }, 0);
    }

    /**
 * Formatea una fecha string en formato "DD MMM" (ej: "25 Dic")
 *
 * Este método parsea y formatea fechas que están en formato "DD-MMMM-YYYY" en español
 * a un formato abreviado más compacto para display en UI.
 *
 * @param {string} date - String de fecha en formato "DD-MMMM-YYYY" (ej: "25-Diciembre-2023")
 * @returns {string} - Fecha formateada como "DD MMM" o mensaje de error
 *
 * @validation
 * - Retorna "Fecha no válida" si el parámetro es falsy
 * - Retorna "Fecha inválida" si el parsing con moment falla
 *
 * @uses moment.js - Para parsing y formateo de fechas en español
 * @format 'DD-MMMM-YYYY' - Formato de entrada esperado
 * @format 'DD MMM' - Formato de salida (ej: "25 Dic")
 *
 * @example
 * // Retorna: "25 Dic"
 * this.getDateInOut("25-Diciembre-2023");
 *
 * @example
 * // Retorna: "01 Ene"
 * this.getDateInOut("01-Enero-2024");
 */
    getDateInOut(date: string): string {
      if (!date) return 'Fecha no válida';

      // Primero parsear la fecha con el formato correcto
      const parsedDate = moment(date, 'DD-MMMM-YYYY', 'es');

      // Verificar si la fecha es válida
      if (!parsedDate.isValid()) {
        console.error('Fecha inválida:', date);
        return 'Fecha inválida';
      }

      // Formatear la salida
      return parsedDate.format('DD MMM');
    }

    /**
 * Obtiene los vuelos internos (excluyendo el primero y último) del itinerario actual
 *
 * Este método crea una copia del array de vuelos y retorna un subarray que excluye
 * el primer y último elemento, que típicamente representan los vuelos de inicio y fin.
 *
 * @returns {any[]} - Array con los vuelos internos (excluyendo primer y último)
 *
 * @operation
 * 1. Crea shallow copy del array flights
 * 2. Usa slice(1, -1) para excluir primer y último elemento
 * 3. Retorna el subarray resultante
 *
 * @example
 * // Si flights = [A, B, C, D, E]
 * // Retorna: [B, C, D]
 * this.getFlightsInternal();
 *
 * @note
 * - Usa spread operator para crear copia superficial
 * - No modifica el array original _actualItinerary.flights
 */
    getFlightsInternal(): any {
      const newArrFlights = [...this._actualItinerary.flights];

      return newArrFlights.slice(1, -1);
    }

    /**
 * Crea y inserta un nuevo vuelo interno en el itinerario actual
 *
 * Este método genera un nuevo vuelo usando newFly() y lo inserta en la penúltima
 * posición del array de vuelos, justo antes del último vuelo existente.
 *
 * @returns {void}
 *
 * @process
 * 1. Genera nuevo vuelo con newFly()
 * 2. Calcula posición de inserción (penúltima posición)
 * 3. Inserta el nuevo vuelo usando splice()
 *
 * @position
 * - Inserta en: flights.length - 1 (penúltima posición)
 * - No elimina elementos existentes (splice con deleteCount = 0)
 *
 * @modification
 * - Modifica directamente _actualItinerary.flights
 * - El array original es alterado con el nuevo elemento
 *
 * @uses newFly() - Método factory para crear vuelos nuevos
 * @uses Array.splice() - Para inserción en posición específica
 *
 * @example
 * // Antes: flights = [A, B, C]
 * this.createFlyInternal();
 * // Después: flights = [A, B, newFly, C]
 */
  createFlyInternal(): void {
    const newFly = this.newFly();

    // Crear una NUEVA referencia del array para que ngOnChanges lo detecte
    this.flightsInternal = [...this.flightsInternal, newFly];
  }


    /**
 * Factory method que crea y retorna un nuevo objeto de vuelo con valores por defecto
 *
 * Este método genera un objeto de vuelo vacío con todas las propiedades inicializadas en null,
 * listo para ser completado con datos específicos. Sirve como template para nuevos vuelos.
 *
 * @returns {any} - Objeto de vuelo con todas las propiedades establecidas en null
 *
 * @structure
 * Propiedades del vuelo:
 * - Información de agente: agent_id
 * - Aerolíneas: airlineIn, airlineOut, airlineIataCodeIn, airlineIataCodeOut
 * - Aeropuertos: airportIn, airportOut, airportIataCodeIn, airportIataCodeOut, id_airport
 * - Fechas y horas: departureIn, departureOut, arrivalIn, arrivalOut
 * - Números de vuelo: flyNumberIn, flyNumberOut
 * - Información de itinerario: itinerary, iata_code
 * - Metadatos: id, created_at, updated_at, deleted_at
 *
 * @purpose
 * - Proporcionar un template consistente para nuevos vuelos
 * - Asegurar que todas las propiedades necesarias estén presentes
 * - Prevenir errores de propiedades undefined
 *
 * @example
 * // Crear nuevo vuelo:
 * const flight = this.newFly();
 * flight.airlineIn = "American Airlines";
 * flight.flyNumberIn = "AA123";
 *
 * @note
 * - Todas las propiedades se inicializan en null
 * - No incluye lógica de validación o business rules
 */
    newFly(): any {
      return {
        agent_id: null,
        airlineIataCodeIn: null,
        airlineIataCodeOut: null,
        airlineIn: null,
        airlineOut: null,
        airportIataCodeIn: null,
        airportIataCodeOut: null,
        airportIn: null,
        airportOut: null,
        arrivalIn: null,
        arrivalOut: null,
        created_at: null,
        deleted_at: null,
        departureIn: null,
        departureOut: null,
        flyNumberIn: null,
        flyNumberOut: null,
        iata_code: null,
        id: null,
        id_airport: null,
        itinerary: null,
        updated_at: null
      }
    }

/**
 * Elimina el vuelo interno (penúltimo) del array de vuelos del itinerario actual
 *
 * Este método remueve el vuelo en la penúltima posición del array de vuelos,
 * manteniendo intactos los vuelos inicial y final del itinerario.
 *
 * @returns {void}
 *
 * @logic
 * - Verifica que existan al menos 2 vuelos en el array
 * - Calcula la posición del penúltimo elemento (length - 2)
 * - Elimina 1 elemento en esa posición usando splice()
 *
 * @conditions
 * - Solo ejecuta si flights.length >= 2
 * - No hace nada si hay menos de 2 vuelos
 *
 * @position
 * - Elimina el elemento en índice: flights.length - 2
 * - Ejemplo: [A, B, C, D] → elimina C → resultado: [A, B, D]
 *
 * @modification
 * - Modifica directamente _actualItinerary.flights
 * - Usa Array.splice() para eliminación in-place
 *
 * @example
 * // Antes: flights = [A, B, C, D]
 * this.deleteFlyInternal();
 * // Después: flights = [A, B, D]
 *
 * @example
 * // Array con 2 elementos: [A, B]
 * this.deleteFlyInternal();
 * // Después: [A] (elimina el penúltimo, que es el primero en este caso)
 */
    deleteFlyInternal(data: any): void {

      if(data.flyExists) {
        this._removeFlight(data.id, false);
      }

        const deleteIndex = this.flightsInternal.length - 2;

        // Eliminar 1 elemento en la posición del anteúltimo
        this.flightsInternal.splice(deleteIndex, 1);

    }

    getFlyItineraries(): void {

    this._itineraryService.getFlightsItinerary(this. _actualItinerary?.id).subscribe({
      next: (res: any) => {
        if(res && res.data && res.data.length > 1) {
            // Hacer una copia del array para no modificar el original
            const dataCopy = [...res.data];
            const firstFlight = dataCopy.shift(); // Remueve el primer elemento

            this.flightsInternal = dataCopy; // El array original queda intacto
        }

      }
    });
  }

  submitFlyInternals(): void {
    this.getFlyItineraries();
  }

  flightsInternalIds(): boolean {
    return this.flightsInternal.every(c => c.id !== null);
  }

getActualFlyInternal(flights: any[], value: string): any {
  if (!flights || flights.length < 1) {
    return null;
  }

  // Descartar primer y último elemento
  const middleFlights = flights;
  const currentDate = new Date();

  // 1. Buscar vuelo actual (en curso)
  const currentFlight = middleFlights.find(flight => {
    try {
      if (!flight?.departureOut || !flight?.arrivalOut) return false;

      const departure = new Date(flight.departureOut);
      const arrival = new Date(flight.arrivalOut);

      return currentDate >= departure && currentDate <= arrival;
    } catch (error) {
      console.error('Error procesando vuelo:', flight, error);
      return false;
    }
  });

  if (currentFlight && currentFlight[value]) {
    return currentFlight[value];
  }

  // 2. Si no hay vuelo actual, buscar próximo vuelo
  const nextFlight = middleFlights
    .filter(flight => flight?.departureOut)
    .sort((a, b) => new Date(a.departureOut).getTime() - new Date(b.departureOut).getTime())
    .find(flight => new Date(flight.departureOut) > currentDate);

  return nextFlight ? nextFlight[value] : null;
}



getDataTooltip(fly: any, index: number, value: string): string {
  const position = this.getPosition(index);
  return this.getDataFlyValue(fly, value, position);
}

private getPosition(index: number): 'first' | 'middle' | 'last' {
  const lastIndex = this.getFlyArr(this._actualItinerary?.flights).length - 1;

  if (index === 0) return 'first';
  if (index === lastIndex) return 'last';
  return 'middle';
}

private getDataFlyValue(fly: any, value: string, position: 'first' | 'middle' | 'last'): string {
  const valueMap = {
    iata: {
      first: () => fly.airportIataCodeIn,
      middle: () => fly.iataCityArrivalOut,
      last: () => fly.airportIataCodeOut
    },
    date: {
      first: () => fly.arrivalIn,
      middle: () => fly.arrivalOut,
      last: () => fly.departureOut
    }
  };

  return valueMap[value]?.[position]?.() || '';
}


getFlyArr(flights: any[]): any[] {

  if (!flights || flights.length === 0) return [];

  // Verificar si los flights han cambiado
  const hasChanged = this.hasFlightsChanged(flights);

  if (!hasChanged && this._cachedResult.length > 0) {
    return this._cachedResult;
  }

  // Calcular nuevo resultado: todos los vuelos originales + primer vuelo al final
  const result = [...flights]; // Copiar todos los vuelos originales

  // Agregar el PRIMER vuelo otra vez como "último" elemento
  if (flights[0]) {
    result.push(flights[0]);
  }

  // Actualizar cache
  this._lastFlights = [...flights];
  this._cachedResult = result;

  return result;
}

private hasFlightsChanged(newFlights: any[]): boolean {
  if (this._lastFlights.length !== newFlights.length) return true;

  for (let i = 0; i < newFlights.length; i++) {
    if (this._lastFlights[i]?.id !== newFlights[i]?.id) {
      return true;
    }
  }

  return false;
}

  onChildAccordionStateChange(isOpen: boolean) {
    this.isChildAccordionOpen = isOpen;
  }

  toggleTimePicker(pickerId: 'arrivalHourIn' | 'departureHourOut', event: Event): void {
    event.stopPropagation();
    this.activeTimePicker = this.activeTimePicker === pickerId ? null : pickerId;
  }

  /**
   * Format-as-you-type handler. Does NOT write to the form control here.
   * Just cleans the typed string and visually inserts a colon after 2 digits.
   * Called on every (input) event.
   */
  _onManualTimeInput(event: Event, controlName: 'arrivalHourIn' | 'departureHourOut'): void {
    const input = event.target as HTMLInputElement;
    const raw = input.value;

    // Strip everything except digits
    const digits = raw.replace(/\D/g, '').slice(0, 4);

    // Insert colon after 2 digits
    let formatted = digits;
    if (digits.length >= 3) {
      formatted = `${digits.slice(0, 2)}:${digits.slice(2)}`;
    } else if (digits.length === 2 && raw.includes(':')) {
      // User typed "14:" — keep the colon
      formatted = `${digits}:`;
    }

    // Only update the DOM value if it changed (prevents cursor jumping)
    if (input.value !== formatted) {
      const cursorPos = input.selectionStart || 0;
      input.value = formatted;
      // Restore cursor position (move it by the diff)
      const newPos = Math.min(cursorPos + (formatted.length - raw.length), formatted.length);
      input.setSelectionRange(newPos, newPos);
    }
  }

  /**
   * Blur handler. Validates and writes the final value to the form control.
   */
  _onTimeInputBlur(controlName: 'arrivalHourIn' | 'departureHourOut', event: FocusEvent): void {
    const input = event.target as HTMLInputElement;
    const dateField = controlName === 'arrivalHourIn' ? 'arrivalDateIn' : 'departureDateOut';
    const dateValue = this._formFlights.get(dateField)?.value;
    const fc = this._formFlights.get(controlName);

    // Normalize: digits only, then re-insert colon
    const digits = input.value.replace(/\D/g, '');
    if (digits.length === 0) {
      // Empty — clear if no date, otherwise use currentTime
      fc?.setValue(dateValue ? this.currentTime : null);
      input.value = dateValue ? this.currentTime : '';
      return;
    }

    // Pad and validate
    const padded = digits.padEnd(4, '0').slice(0, 4);
    const hours = parseInt(padded.slice(0, 2), 10);
    const minutes = parseInt(padded.slice(2, 4), 10);

    if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
      // Invalid — revert
      const prev = this._previousTimeValues[controlName];
      const fallback = prev || (dateValue ? this.currentTime : null);
      fc?.setValue(fallback);
      input.value = fallback || '';
      return;
    }

    const formatted = `${padded.slice(0, 2)}:${padded.slice(2, 4)}`;
    fc?.setValue(formatted);
    input.value = formatted;
    this._previousTimeValues[controlName] = formatted;
  }

  closeTimePicker(): void {
    this.activeTimePicker = null;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.activeTimePicker) {
      const target = event.target as HTMLElement;
      // Check if click was inside any wheel-picker-wrapper
      const pickerWrapper = target.closest('.wheel-picker-wrapper');
      if (!pickerWrapper) {
        this.activeTimePicker = null;
      }
    }
  }

}
